import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const STORAGE_KEY = "lgmg_lang";

const resources = {
  es: {
    translation: {
      months: {
        ene: "Ene", feb: "Feb", mar: "Mar", abr: "Abr", may: "May", jun: "Jun",
        jul: "Jul", ago: "Ago", sep: "Sep", oct: "Oct", nov: "Nov", dic: "Dic",
      },
      // ===== Common buttons & verbs =====
      common: {
        save: "Guardar",
        cancel: "Cancelar",
        create: "Crear",
        delete: "Eliminar",
        edit: "Editar",
        close: "Cerrar",
        accept: "Aceptar",
        loading: "Cargando…",
        saving: "Guardando…",
        creating: "Creando…",
        generating: "Generando…",
        search: "Buscar",
        new: "Nuevo",
        actions: "Acciones",
        status: "Estado",
        date: "Fecha",
        name: "Nombre",
        area: "Área",
        notes: "Observaciones",
        yes: "Sí",
        no: "No",
        refresh: "Refrescar",
        download: "Descargar",
        upload: "Subir",
        confirm: "Confirmar",
        all: "Todos",
        none: "Ninguno",
        back: "Volver",
        next: "Siguiente",
        accessDenied: "Acceso denegado",
        notFound: "No encontrado",
        signOut: "Cerrar sesión",
        install: "Instalar app",
      },
      // ===== Roles =====
      role: {
        gerente: "Gerente",
        supervisor: "Supervisor",
        supervisor_ehs: "Supervisor EHS",
        almacen: "Almacén",
        lider_area: "Líder de área",
        coordinador_almacen: "Coordinador Almacén",
        coordinador_ehs: "Coordinador EHS",
        especialista_ehs: "Especialista EHS",
        logistica_ehs: "Logística EHS",
        servicio_medico: "Servicio Médico",
        usuario: "Usuario",
        super: "Super Admin",
      },
      // ===== Sidebar =====
      sidebar: {
        boardEHS: "Tablero EHS",
        executive: "Ejecutivo",
        safety: "Seguridad",
        safetyDashboard: "Dashboard Seguridad",
        newAssessment: "Nueva Evaluación",
        history: "Histórico de Análisis",
        nomInspections: "Inspecciones NOM",
        autoCapa: "Administración JSA",
        a3Reports: "Reportes A3",
        capaActions: "Acciones JSA Automática",
        normsSTPS: "Normas STPS",
        health: "Salud Ocupacional",
        environment: "Medio Ambiente",
        training: "Capacitación",
        trainingList: "Listado",
        trainingPlan: "Plan Anual",
        trainingAttendance: "Asistencias",
        generateDC3: "Generar DC-3",
        projects: "Proyectos",
        config: "Configuración",
        users: "Usuarios",
        permissions: "Permisos por Rol",
        audit: "Auditoría",
        lessons: "Lecciones Aprendidas",
        auditLog: "Bitácora",
        superAdminMenu: "Super Admin (Menú)",
        epp: "EPP",
        eppDashboard: "Dashboard EPP",
        eppInventory: "Inventario",
        eppMovements: "Movimientos",
        eppRequests: "Solicitudes",
        eppAssignments: "Asignaciones",
        eppMatrix: "Matriz EPP",
        healthDashboard: "Dashboard Salud",
        medicalConsultations: "Consultas Médicas",
        medications: "Medicamentos",
        medicalSurveillance: "Vigilancia Médica",
        ergonomics: "Ergonomía",
        psychosocial: "Riesgos Psicosociales",
        environmentDashboard: "Dashboard Ambiente",
        waste: "Residuos",
        exitPasses: "Pases de Salida",
        waterConsumption: "Consumo Agua",
        energyConsumption: "Consumo Energía",
        legalCompliance: "Cumplimiento Legal",
        accessControl: "Control de accesos",
        safetyPolicy: "Política de Seguridad",
        followUpProgram: "Programa de Seguimiento",
        unsafeActsConditions: "Actos y Condiciones Inseguras",
        workPermits: "Permisos de Trabajo",
        procedures: "Procedimientos",
        plantInspections: "Inspecciones de Planta",
        eppManagement: "Gestión de EPP",
        disabilityControl: "Control de Incapacidades",
        wasteLog: "Bitácora de Residuos",
        companies: "Empresas",
        suppliers: "Proveedores",
        plantAreas: "Áreas de Planta",
        areaRegistry: "Registro de áreas",
        supDirectory: "Directorio",
        supLegalDocs: "Documentación Legal",
        supAuthorizedPersonnel: "Personal Autorizado",
        supVehicles: "Vehículos",
        supDailyCheckin: "Check-in Diario",
      },
      // ===== Auditoría NOM =====
      audit: {
        title: "Auditoría NOM",
        subtitle: "Cumplimiento normativo STPS · Checklist por requisito con evidencias y revisión",
        newAudit: "Nueva Auditoría",
        newAuditDesc: "Crea una auditoría anual con los 88 requisitos NOM precargados.",
        year: "Año",
        created: "Auditoría creada",
        createError: "No se pudo crear la auditoría",
        loadError: "Error al cargar la auditoría",
        empty: "Sin auditorías",
        emptyDesc: "Crea tu primera auditoría anual de cumplimiento NOM.",
        open: "Abrir",
        backToList: "Volver a auditorías",
        downloadPdf: "Descargar PDF",
        pdfError: "No se pudo generar el PDF",
        globalCompliance: "Cumplimiento global",
        total: "Total",
        cumple: "Cumple",
        noCumple: "No cumple",
        enProceso: "En proceso",
        sinEvaluar: "Sin evaluar",
        allFilter: "Todos",
        searchPlaceholder: "Buscar por NOM, requisito o responsable…",
        noResults: "No hay requisitos que coincidan con el filtro.",
        evidences: "evidencias",
        section: "Sección(es)",
        establishes: "¿Qué establece?",
        toEvidence: "¿Qué debe entregar / evidenciar?",
        complianceStatus: "Estatus de cumplimiento",
        responsibleName: "Nombre del responsable",
        responsibleArea: "Área responsable",
        deadline: "Fecha compromiso",
        observations: "Evidencia / Observaciones",
        saved: "Requisito actualizado",
        saveError: "No se pudo guardar",
        evidence: "Evidencias",
        noEvidence: "Sin evidencias cargadas.",
        uploadEvidence: "Subir evidencia",
        uploading: "Subiendo…",
        evidenceAdded: "Evidencia agregada",
        uploadError: "Error al subir el archivo",
        deleteError: "No se pudo eliminar",
        reviewFlow: "Flujo de revisión",
        reviewed: "Revisado",
        approved: "Aprobado",
        reviewedBy: "Revisado por (Supervisor EHS)",
        approvedBy: "Aprobado por (Gerente Operación)",
        markReviewed: "Revisar (Supervisor EHS)",
        approve: "Aprobar (Gerente Operación)",
        reject: "Rechazar",
        rejectReason: "Motivo del rechazo:",
        rejectedReason: "Motivo de rechazo",
        actionDone: "Acción aplicada",
        actionError: "No se pudo aplicar la acción",
        rev_pendiente: "Pendiente",
        rev_revisado: "Revisado (Supervisor)",
        rev_aprobado: "Aprobado (Gerente)",
        rev_rechazado: "Rechazado",
      },
      // ===== Bitácora de auditoría =====
      audit_log: {
        title: "Bitácora de auditoría",
        subtitle: "Registro de eventos de seguridad y acciones clave en toda la aplicación",
        exportCsv: "Exportar CSV",
        filters: "Filtros",
        clear: "Limpiar",
        searchPlaceholder: "Buscar por usuario, registro o detalle…",
        allModules: "Todos los módulos",
        allActions: "Todas las acciones",
        allUsers: "Todos los usuarios",
        entries: "Registros",
        noEntries: "Sin registros que coincidan con los filtros.",
        colDate: "Fecha/Hora",
        colUser: "Usuario",
        colAction: "Acción",
        colModule: "Módulo",
        colTarget: "Registro afectado",
        colIp: "IP",
        loadError: "Error al cargar la bitácora",
        exportError: "No se pudo exportar",
        forbidden: "Sólo el Super Admin puede ver la bitácora",
      },
      // ===== Control de Accesos =====
      access: {
        title: "Control de Accesos",
        subtitle: "Define qué módulos del menú puede ver cada usuario",
        loadError: "Error al cargar la información",
        searchUser: "Buscar usuario…",
        noUsers: "Sin usuarios",
        pickUser: "Selecciona un usuario para configurar sus accesos",
        customAccess: "Accesos personalizados",
        unconfigured: "Sin configurar (sin acceso)",
        fullAccess: "Acceso completo",
        selectAll: "Todos",
        selectNone: "Ninguno",
        hint: "Marca un módulo para dar acceso a su tablero. Despliega (›) para activar pantallas específicas. Cada casilla es independiente.",
        screens: "pantallas",
        mainOnly: "tablero",
        childHint: "Cada pantalla es independiente: marcar el módulo padre solo da acceso a su tablero principal, no a todas las pantallas.",
        superNote: "El Super Admin tiene acceso completo a todos los módulos y no puede restringirse desde aquí.",
        saveAccess: "Guardar accesos",
        saved: "Accesos actualizados",
        saveError: "No se pudo guardar",
        clearAccess: "Quitar todos los accesos",
        clearedDone: "Se quitaron todos los accesos del usuario",
        modulesEnabled: "módulos activos",
        emptyWarning: "No has seleccionado ningún módulo. Si guardas así, este usuario NO verá ninguna opción en el menú. ¿Deseas continuar?",
      },
      // ===== Login =====
      login: {
        title: "Iniciar Sesión",
        email: "Correo",
        password: "Contraseña",
        signIn: "Ingresar",
        emailPlaceholder: "usuario@lgmg.com",
        subtitle: "Sistema Integral · Salud, Seguridad y Medio Ambiente",
        footer: "Administración de Seguridad, Salud y Medio Ambiente",
        norms: "STPS · OSHA · ISO 45001 · ISO 14001",
        invalidCredentials: "Credenciales inválidas",
        remember: "Recordarme",
        forgot: "¿Olvidaste tu contraseña?",
        forgotTitle: "Recuperar contraseña",
        forgotDesc: "Escribe tu correo y te enviaremos un enlace para crear una nueva contraseña.",
        forgotSend: "Enviar enlace",
        forgotSent: "Si el correo está registrado, te enviaremos un enlace para restablecer tu contraseña.",
      },
      bbs: {
        title: "BBS · Seguridad Basada en el Comportamiento",
        subtitle: "Observación de comportamientos seguros e inseguros · % seguro por área y categoría.",
        newObs: "Nueva observación", pdf: "PDF", search: "Buscar por observador, área…",
        observations: "observaciones", kpiObs: "OBSERVACIONES", kpiPct: "% SEGURO",
        kpiSafe: "COMPORT. SEGUROS", kpiUnsafe: "COMPORT. INSEGUROS",
        byCategory: "Comportamientos por categoría", pctByArea: "% Seguro por área",
        trend: "Tendencia de % seguro (mensual)", noData: "Sin datos aún",
        objective: "Objetivo", inObjective: "En objetivo", atRisk: "En riesgo", offObjective: "Fuera de objetivo",
        safe: "Seguro", unsafe: "Inseguro", save: "Guardar", cancel: "Cancelar",
        colDate: "Fecha", colObserver: "Observador", colArea: "Área", colSafe: "Seguros",
        colUnsafe: "Inseguros", colPct: "% Seguro", colDesc: "Descripción", emptyList: "Sin observaciones. Registra la primera.",
        formTitle: "Nueva observación BBS", observer: "Observador", area: "Área", date: "Fecha",
        shift: "Turno", peopleObserved: "Personas observadas", behaviors: "Comportamientos observados",
        descObserved: "Descripción de lo observado", immediateAction: "Acción inmediata", commitment: "Compromiso / seguimiento",
        scorecard: "Scorecard de indicadores BBS", totalWorkers: "Total trabajadores",
        indicators: "Indicadores (scorecard)", qualityObs: "Observación de calidad", recurrent: "Comportamiento reincidente",
        actionClosed: "Acción cerrada en plazo", closeDays: "Días de cierre",
        colIndicator: "Indicador", colFormula: "Fórmula", colTarget: "Meta", colResult: "Resultado", colStatus: "Estatus",
        meets: "Cumple", notMeet: "No cumple", days: "días",
        scHint: "Cobertura y participación requieren el «Total trabajadores». Calidad, cierre, tiempo y reincidencia se calculan de los campos capturados en cada observación.",
        sc1: "Cobertura de observaciones", sc2: "Calidad de las observaciones", sc3: "% de comportamientos críticos seguros",
        sc4: "Tasa de cierre de acciones", sc5: "Tiempo promedio de cierre", sc6: "Participación de los trabajadores",
        sc7: "Reincidencia de comportamientos de riesgo",
        errObs: "Observador y área son obligatorios", saved: "Observación BBS registrada",
        deleted: "Eliminada", confirmDel: "¿Eliminar esta observación?", cfgSaved: "Configuración actualizada",
        na: "N/D", noDataShort: "Sin datos", topObservers: "Top observadores", colCategory: "Categoría",
        objectiveLine: "{{label}} — {{pct}}% seguro (objetivo {{meta}}%)",
        objectiveBtn: "Objetivo: {{n}}%", totalWorkersLabel: "Total trabajadores: {{n}}",
        areaPh: "Ej. Soldadura", shiftPh: "Matutino / Vespertino",
        pdfHeaderTitle: "BBS Seguridad Basada en el Comportamiento",
        pdfHeaderSub: "Observaciones de comportamientos seguros e inseguros",
        pdfSemLine: "{{label}}: {{pct}}% de {{meta}}% objetivo",
        pdfFooter: "HSE · BBS · Confidencial",
        pdfPage: "Página {{p}} de {{total}}",
        pdfCardObs: "OBSERVACIONES", pdfCardSafe: "% SEGURO", pdfCardTarget: "OBJETIVO", pdfCardUnsafe: "INSEGUROS",
        pdfColObs: "Observaciones",
        f1: "Trabajadores observados / Total trabajadores × 100",
        f2: "Observaciones de calidad / Total observaciones × 100",
        f3: "Comportamientos seguros / Total observados × 100",
        f4: "Acciones cerradas en plazo / Acciones generadas × 100",
        f5: "Suma de días / Total acciones cerradas",
        f6: "Trabajadores que participan / Total trabajadores × 100",
        f7: "Reincidentes / Total comportamientos de riesgo × 100",
        cat: {
          "Uso de EPP": "Uso de EPP",
          "Posición / Ergonomía": "Posición / Ergonomía",
          "Herramientas y equipo": "Herramientas y equipo",
          "Procedimientos / Permisos": "Procedimientos / Permisos",
          "Orden y limpieza": "Orden y limpieza",
          "Reacción de las personas": "Reacción de las personas",
          "Otros": "Otros",
        },
      },
      // ===== Executive Dashboard =====
      executive: {
        title: "Dashboard Ejecutivo HSE",
        subtitle: "{{company}} · Seguridad · Salud · Ambiente · Indicadores Integrales",
        updated: "Actualizado",
        period: "Período",
        thisMonth: "Este mes",
        quarter: "Trimestre",
        last12m: "12 meses",
        total: "Total",
        avgCompliance: "Cumplimiento promedio",
        inspections: "Inspecciones realizadas",
        criticalFindings: "Hallazgos críticos",
        overdueCAPA: "CAPAs vencidas",
        monthlyTrend: "Tendencia mensual (6 meses)",
        monthlyTrendSubtitle: "% cumplimiento + flujo CAPA",
        capaStatus: "Estado CAPA",
        capaByOrigin: "CAPAs por origen",
        capaBySeverity: "CAPAs por nivel",
        autoOrigin: "Procedencia automática",
        severity: "Severidad",
        compliancePct: "% Cumplimiento",
        capaOpen: "CAPAs abiertas",
        capaClosed: "CAPAs cerradas",
        open: "Abiertas",
        inProgress: "En progreso",
        closed: "Cerradas",
        overdue: "Vencidas",
        extreme: "Extremo",
        high: "Alto",
        medium: "Medio",
        low: "Bajo",
        sourceNom: "Inspecciones NOM",
        sourceVigilancia: "Vigilancia Médica",
        sourceErgonomia: "Ergonomía",
        sourcePsicosocial: "NOM-035",
        sourceCumplimiento: "Cumplimiento NOMs",
        pMonth: "Mes",
        pTotal: "Total",
        year: "Año",
        yearTooltipDisabled: "El año aplica solo a los trimestres (Q1–Q4)",
        yearTooltip: "Selecciona el año del trimestre",
        viewDetail: "Ver detalle",
        viewDetailArrow: "Ver detalle →",
        loading: "Cargando dashboard…",
        loadError: "No se pudo cargar el dashboard.",
        pdfDownloaded: "PDF descargado",
        pdfError: "Error al exportar PDF: ",
        noData: "Sin datos.",
        inspByMonth: "Inspecciones por mes",
        last6m: "Últimos 6 meses",
        inspectionsName: "Inspecciones",
        capaEffectiveness: "Efectividad de CAPAs",
        closeRateSub: "Tasa de cierre del período",
        closedLower: "cerradas",
        capasClosedLabel: "CAPAs cerradas",
        avgCloseDays: "días prom. cierre",
        findingsBySeverity: "Hallazgos por severidad",
        criticalVsNon: "Críticos vs no críticos",
        noFindings: "Sin hallazgos registrados.",
        critical: "Críticos",
        nonCritical: "No críticos",
        capaName: "CAPAs",
        top5Areas: "Top 5 áreas con más hallazgos",
        findingsName: "Hallazgos",
        top5Noms: "Top 5 NOMs con más hallazgos",
        noFindingsShort: "Sin hallazgos.",
        capaByArea: "CAPAs por área",
        capaByAreaSub: "Acciones correctivas generadas por área",
        noCapaPeriod: "Sin CAPAs en el período.",
        capaByResp: "CAPAs por responsable",
        capaByRespSub: "Carga de acciones por persona asignada",
        actsVsConditions: "Actos vs Condiciones Inseguras",
        totalLabel: "Total",
        openLabel: "Abiertas",
        acTrendSub: "Tendencia mensual (últimos 6 meses)",
        unsafeActs: "Actos inseguros",
        unsafeConditions: "Condiciones inseguras",
        noRecordsPeriod: "Sin registros en el período.",
        acByArea: "Actos y condiciones por área",
        top8Areas: "Top 8 áreas con más observaciones",
        acts: "Actos",
        conditions: "Condiciones",
        bodyPart: "Parte del cuerpo afectada",
        incidentsPeriod: "Incidentes en el período",
        bodyPartSub: "Lesiones por zona corporal (top 10)",
        incidentsName: "Incidentes",
        noBodyPart: "Sin incidentes con parte del cuerpo registrada en el período.",
        incBySeverity: "Incidentes por gravedad",
        severityScale: "Leve · Moderado · Grave · Fatal",
        noIncidentsPeriod: "Sin incidentes en el período.",
        incByType: "Incidentes por tipo",
        typeScale: "Accidente · Casi accidente · Primeros auxilios",
        healthPanel: "Salud Ocupacional",
        exams: "Exámenes",
        notFit: "No aptos",
        fitRestrictions: "Apto c/restricciones",
        ergoVeryHigh: "Ergonomía Muy Alto",
        nom035Clinical: "NOM-035 atención clínica",
        medicalFitDist: "Distribución de aptitud médica",
        fit: "Apto",
        withRestrictions: "Con restricciones",
        notFitSingle: "No apto",
        eppPanel: "EPP",
        eppItems: "Ítems EPP",
        lowStock: "Stock bajo",
        pendingRequests: "Solicitudes pendientes",
        expiring7d: "Por vencer (7d)",
        expired: "Vencidos",
        envPanel: "Medio Ambiente",
        rpGenerated12m: "RP generados 12m",
        co2Year: "Huella CO₂e año",
        permitsExpiring: "Permisos por vencer",
        permitsExpired: "Permisos vencidos",
        quickAccess: "Acceso Rápido",
        qNewEval: "Nueva Evaluación",
        qA3: "Reportes A3",
        qNorms: "Normas STPS",
        qInventory: "Inventario EPP",
        qTraining: "Capacitaciones",
        qWaste: "Residuos",
        qActs: "Actos y Condiciones Inseguras",
        disabilityControl: "Control de Incapacidades",
        incShort: "Incapacidades",
        lostDays: "Días perdidos",
        activeCases: "Casos activos",
        mainCause: "Causa principal",
        lostDaysAccum: "Días perdidos acumulados",
        activeCasesFollow: "Casos activos / seguimiento",
        maternityPct: "% participación maternidad",
        avgDaysCase: "Promedio de días por caso",
        daysUnit: "días",
        rpLoading: "Cargando reporte de residuos…",
        rpTitle: "Gestión de Residuos Peligrosos",
        rpCarrier: "Transportista",
        rpFinalDisposal: "Disposición Final",
        rpPeriod: "Periodo",
        rpTotalWeight: "Peso Total Generado",
        rpEquivTo: "equivalente a",
        rpContainers: "Contenedores Totales",
        rpContainersSub: "Totes, Tambos y Tarimas",
        rpTotalSpend: "Gasto Total",
        rpNoVat: "sin IVA",
        rpManifests: "Manifiestos Emitidos",
        rpNoWaste: "Sin residuos peligrosos registrados en",
        rpWeightByMonth: "Peso Generado por Mes (kg)",
        rpDistByType: "Distribución por Tipo de Residuo",
        rpGenByArea: "Generación por Área (kg)",
        rpMonthlySummary: "Resumen Mensual de Manifiestos",
        rpThMonth: "Mes",
        rpThManifests: "Manifiestos",
        rpThWeight: "Peso (kg)",
        rpThCont: "Cont.",
        rpThSpend: "Gasto",
        rpManifestsWord: "manifiestos",
        execAiTitle: "Resumen Ejecutivo (IA)",
        focosLabel: "Focos de atención",
        execGenerating: "Generando…",
        execTablesTitle: "Tablas ejecutivas",
        tblAreasTitle: "Áreas de mayor riesgo",
        tblAreasEmpty: "Sin hallazgos en el periodo",
        colArea: "Área",
        colFindings: "Hallazgos",
        tblNomsTitle: "Hallazgos por NOM",
        tblNomsEmpty: "Sin hallazgos por NOM",
        colNorm: "Norma",
        tblCapasTitle: "CAPAs por responsable",
        tblCapasEmpty: "Sin CAPAs en el periodo",
        colResponsible: "Responsable",
        colCapas: "CAPAs",
        tblExamsTitle: "Exámenes médicos vencidos / por vencer",
        tblExamsEmpty: "Vigilancia médica al día",
        colWorker: "Trabajador",
        colStatus: "Estado",
        statusExpired: "Vencido",
      },
      dir: {
        title: "DIR · Control de Gastos HSE",
        subtitle: "Presupuesto anual vs. gasto real de Seguridad, Salud, Ambiental y Capacitación.",
        loading: "Cargando control de gastos…",
        pdf: "PDF",
        excel: "Excel",
        budgetBtn: "Presupuesto",
        addExpense: "Registrar gasto",
        kpiBudget: "Presupuesto anual",
        kpiSpent: "Gastado",
        kpiAvailable: "Disponible",
        kpiPct: "% ejercido",
        fModule: "Módulo",
        fArea: "Área",
        fType: "Tipo de gasto",
        fFrom: "Desde",
        fTo: "Hasta",
        fWeek: "Semana",
        all: "Todos",
        allF: "Todas",
        clearFilters: "Limpiar filtros",
        weekPriority: "La semana seleccionada tiene prioridad sobre el rango de fechas.",
        monthlySpend: "Gasto mensual por módulo",
        distribution: "Distribución",
        noExpensesReg: "Sin gastos registrados",
        overBudget: "Sobregiro",
        ofWord: "de",
        available: "Disponible",
        exceeded: "Excedido",
        noExpensesModule: "Sin gastos en este módulo",
        detailTitle: "Detalle de gastos",
        thDate: "Fecha",
        thModule: "Módulo",
        thSubmodule: "Submódulo",
        thArea: "Área",
        thConcept: "Concepto",
        thAmount: "Monto",
        thProvider: "Proveedor",
        noExpensesFilters: "Sin gastos con los filtros actuales",
        dlgTitle: "Registrar gasto",
        editTitle: "Editar gasto",
        edit: "Editar",
        updated: "Gasto actualizado",
        saveChanges: "Guardar cambios",
        lblModule: "Módulo *",
        lblType: "Tipo de gasto",
        lblSubmodule: "Submódulo *",
        lblConcept: "Concepto *",
        phConcept: "Descripción del gasto",
        lblAmount: "Monto (MXN) *",
        lblDate: "Fecha *",
        lblArea: "Área",
        phArea: "Producción, Almacén…",
        lblProvider: "Proveedor",
        lblFolio: "Folio / Factura (trazabilidad)",
        phFolio: "A-12345",
        lblNote: "Nota (opcional)",
        phNote: "Detalle adicional para auditoría",
        cancel: "Cancelar",
        record: "Registrar",
        saving: "Guardando…",
        presuTitle: "Presupuesto anual {{year}} (MXN)",
        loadingShort: "Cargando…",
        totalAnnual: "Total anual",
        moveBudget: "Mover presupuesto",
        from: "De",
        to: "A",
        amountToMove: "Monto a mover",
        move: "Mover",
        moving: "Moviendo…",
        moveHint: "Traslada presupuesto de un módulo a otro sin cambiar el total anual.",
        reassignHistory: "Historial de reasignaciones",
        saveBudget: "Guardar presupuesto",
        errLoad: "No se pudo cargar el control de gastos",
        errExport: "No se pudo exportar",
        confirmDelete: "¿Eliminar el gasto \"{{concept}}\" ({{amount}})?",
        deleted: "Gasto eliminado",
        errDelete: "No se pudo eliminar",
        conceptAmountReq: "Concepto y monto son obligatorios",
        recorded: "Gasto registrado",
        errRecord: "No se pudo registrar",
        budgetSaved: "Presupuesto {{year}} guardado",
        errSave: "No se pudo guardar",
        moveGt0: "Indica un monto a mover mayor a 0",
        fromToDiff: "Origen y destino deben ser distintos",
        moved: "Se movieron {{amount}} de {{from}} a {{to}}",
        errReassign: "No se pudo reasignar",
        alertOver: "{{module}}: {{pct}}% ejercido (sobregiro de {{amount}})",
        alertNear: "{{module}}: {{pct}}% del presupuesto ejercido",
        modules: {
          seguridad: "Seguridad",
          salud: "Salud Ocupacional",
          ambiental: "Ambiental",
          capacitacion: "Capacitación",
        },
        tipos: {
          "Material/Consumible": "Material/Consumible",
          "Servicio": "Servicio",
          "Equipo (CAPEX)": "Equipo (CAPEX)",
          "Análisis/Estudio": "Análisis/Estudio",
          "Disposición/Manejo": "Disposición/Manejo",
          "Capacitación": "Capacitación",
          "Otro": "Otro",
        },
        submodulos: {
          "EPP (Equipo de Protección Personal)": "EPP (Equipo de Protección Personal)",
          "Inspecciones y Auditorías NOM": "Inspecciones y Auditorías NOM",
          "Señalización y Permisos de Trabajo": "Señalización y Permisos de Trabajo",
          "Simulacros y Emergencias": "Simulacros y Emergencias",
          "Equipo contra incendio": "Equipo contra incendio",
          "Exámenes médicos y Vigilancia": "Exámenes médicos y Vigilancia",
          "Medicamentos y Botiquín": "Medicamentos y Botiquín",
          "Consultas y Servicio Médico": "Consultas y Servicio Médico",
          "Estudios especiales (audiometría, espirometría)": "Estudios especiales (audiometría, espirometría)",
          "Ergonomía y Psicosocial (NOM-035)": "Ergonomía y Psicosocial (NOM-035)",
          "Manejo de residuos (RP/RME/RSU)": "Manejo de residuos (RP/RME/RSU)",
          "Monitoreo y análisis (agua, aire, ruido)": "Monitoreo y análisis (agua, aire, ruido)",
          "Permisos y licencias (SEMARNAT)": "Permisos y licencias (SEMARNAT)",
          "Disposición final y transporte": "Disposición final y transporte",
          "Certificaciones ambientales": "Certificaciones ambientales",
          "Cursos internos": "Cursos internos",
          "Cursos externos e instructores": "Cursos externos e instructores",
          "Certificaciones y DC-3": "Certificaciones y DC-3",
          "Material didáctico": "Material didáctico",
          "Plataforma y licencias": "Plataforma y licencias",
        },
      },
      areasAdmin: {
        title: "Áreas de Planta",
        subtitle: "Administra las áreas. Alimentan a Ergonomía, Actos y Condiciones, JSA, Análisis de Riesgo e Inspecciones.",
        newArea: "Nueva Área",
        editArea: "Editar Área",
        thName: "Nombre",
        thDescription: "Descripción",
        thActions: "Acciones",
        loading: "Cargando...",
        empty: "No hay áreas registradas todavía.",
        edit: "Editar",
        delete: "Eliminar",
        optional: "opcional",
        cancel: "Cancelar",
        save: "Guardar",
        saving: "Guardando...",
        created: "Área creada",
        updated: "Área actualizada",
        deleted: "Área eliminada",
        confirmDelete: "¿Eliminar el área \"{{name}}\"?",
      },

      usersAdmin: {
        title: "Gestión de Usuarios",
        subtitle: "Usuario · Supervisor · Almacén · Gerente",
        viewAllCompanies: "Ver de todas las empresas",
        newUser: "Nuevo Usuario",
        mainNoCompany: "Principal / Sin empresa",
        viewAll: "Ver todos",
        thName: "Nombre",
        thEmail: "Email",
        thRole: "Rol",
        thStatus: "Estado",
        thCompany: "Empresa",
        thArea: "Área",
        thEmployeeId: "ID Empleado",
        thActions: "Acciones",
        loading: "Cargando...",
        suspended: "Suspendido",
        active: "Activo",
        menu: "Menú",
        permissions: "Permisos",
        activateAccount: "Activar cuenta",
        suspendAccount: "Suspender cuenta",
        deleteAccount: "Eliminar cuenta",
        noCompany: "Sin empresa",
        fullName: "Nombre completo",
        password: "Contraseña",
        pwdHint: "Mín. 12 caracteres, con mayúscula, minúscula, número y símbolo.",
        area: "Área",
        selectPlaceholder: "Seleccionar...",
        optional: "opcional",
        cancel: "Cancelar",
        create: "Crear",
        creating: "Creando...",
        userCreated: "Usuario creado",
        userAssigned: "Usuario asignado a la empresa",
        userDeleted: "Usuario eliminado",
        roleUpdated: "Rol actualizado",
        accountSuspended: "Cuenta suspendida",
        accountActivated: "Cuenta activada",
        confirmDelete: "¿Eliminar a {{name}}?",
        confirmSuspend: "¿Suspender la cuenta de {{name}}? No podrá iniciar sesión hasta que la reactives.",
        pwdStrength: "Requisitos de contraseña",
        pwdReqLength: "Al menos 12 caracteres",
        pwdReqUpper: "Una mayúscula (A-Z)",
        pwdReqLower: "Una minúscula (a-z)",
        pwdReqDigit: "Un número (0-9)",
        pwdReqSymbol: "Un símbolo (!@#$…)",
        menuVisible: "Menú visible",
        menuCustomHint: "Este usuario tiene accesos personalizados. Marca/desmarca para ajustar.",
        menuNoneHint: "Sin accesos configurados. Marca las casillas para asignar los módulos visibles.",
        menuUpdated: "Menú actualizado para",
        removeAccess: "Quitar accesos",
        confirmClearMenu: "¿Quitar todos los accesos de menú de este usuario?",
        menuAccessRemoved: "Accesos de menú quitados",
        save: "Guardar",
        saving: "Guardando…",
        saveItems: "Guardar ({{count}} ítems)",
        capsTitle: "Permisos de acción",
        capsAlwaysAll: "El Gerente y el Super Admin siempre tienen todos los permisos.",
        capsHint: "Activa o desactiva lo que este usuario puede hacer en toda la app.",
        savePerms: "Guardar permisos",
        permsUpdated: "Permisos actualizados para",
        capDelete: "Eliminar",
        capDeleteDesc: "Puede eliminar registros (proyectos, residuos, usuarios, etc.).",
        capEdit: "Editar",
        capEditDesc: "Puede modificar registros existentes.",
        capPdf: "Descargar PDF",
        capPdfDesc: "Puede exportar/descargar reportes en PDF.",
        capIa: "Usar IA",
        capIaDesc: "Puede usar los botones de generación con IA (procedimientos, medidas de control).",
      },

      ehs: {
        section: "Seguridad Industrial",
        title: "Desempeño EHS",
        subtitle: "KPIs OSHA/STPS · Frecuencia · Severidad · Días perdidos",
        registerIncident: "Registrar incidente",
        configure: "Configurar",
        from: "Desde",
        to: "Hasta",
        area: "Área",
        supervisor: "Supervisor",
        allAreas: "Todas las áreas",
        all: "Todos",
        hhPeriod: "HH período",
        avgWorkers: "Promedio trab.",
        ifFreq: "IF Frecuencia",
        isSev: "IS Severidad",
        lostDays: "Días perdidos",
        totalIncidents: "Incidentes totales",
        registrables: "Accidentes registrables",
        thresholdSub: "Umbral 🟢 ≤{{g}} · 🟡 ≤{{y}}",
        accumPeriod: "acumulados período",
        incidentsSub: "{{acc}} acc. · {{near}} casi · {{fa}} 1eros aux.",
        rateSub: "Tasa /100 trab: {{rate}}",
        monthlyTrend: "Tendencia mensual (IF & IS)",
        incidentsByArea: "Incidentes por área",
        bySeverity: "Por gravedad",
        noIncidentsPeriod: "Sin incidentes en el período.",
        accidents: "Accidentes",
        nearMisses: "Casi accidentes",
        incidents: "Incidentes",
        loading: "Cargando dashboard EHS…",
        noData: "Sin datos.",
        dlgTitle: "Registrar incidente",
        dlgDesc: "Registra accidentes, casi accidentes y primeros auxilios.",
        type: "Tipo",
        date: "Fecha",
        severity: "Gravedad",
        typeAccident: "Accidente",
        typeNear: "Casi accidente",
        typeFirstAid: "Primeros auxilios",
        sevLeve: "Leve",
        sevModerado: "Moderado",
        sevGrave: "Grave",
        sevFatal: "Fatal",
        supervisorName: "Nombre del supervisor",
        affectedWorker: "Trabajador afectado",
        workerPlaceholder: "Nombre o ID",
        lostDaysField: "Días perdidos",
        recordable: "Registrable (OSHA/STPS)",
        bodyPart: "Parte del cuerpo afectada",
        bodyPartPlaceholder: "Ej. mano izquierda, ojo, espalda",
        description: "Descripción",
        descPlaceholder: "¿Qué ocurrió?",
        immediateAction: "Acción correctiva inmediata",
        actionPlaceholder: "¿Qué se hizo?",
        cancel: "Cancelar",
        register: "Registrar",
        saving: "Guardando…",
        yes: "Sí",
        no: "No",
        selectArea: "Selecciona el área",
        describeAccident: "Describe el accidente",
        incidentSaved: "Incidente registrado",
        incidentUpdated: "Incidente actualizado",
        incidentDeleted: "Incidente eliminado",
        editTitle: "Editar incidente",
        saveChanges: "Guardar cambios",
        recordsTitle: "Incidentes registrados",
        records: "registros",
        actions: "Acciones",
        edit: "Editar",
        delete: "Eliminar",
        confirmDelete: "¿Eliminar este incidente? Esta acción no se puede deshacer.",
        errorSaving: "Error al registrar",
        errorLoadDash: "Error al cargar dashboard EHS",
        cfgTitle: "Configurar EHS",
        cfgDesc: "Plantilla mensual y umbrales semáforo",
        thresholds: "Umbrales semáforo",
        ifGreen: "IF Verde ≤",
        ifYellow: "IF Amarillo ≤",
        isGreen: "IS Verde ≤",
        isYellow: "IS Amarillo ≤",
        thresholdHint: "Si IF supera amarillo → 🔴 rojo. Mismo criterio para IS.",
        monthlyWorkforce: "Plantilla mensual",
        defaultLine: "Default: {{w}} trabajadores × {{h}} h/mes",
        colMonth: "Mes",
        colWorkers: "Trabajadores",
        colHours: "Horas/trab.",
        colHH: "HH total",
        configSaved: "Configuración guardada",
        errorLoadCfg: "Error al cargar configuración",
        save: "Guardar",
        selectPlaceholder: "Selecciona",
        good: "Bueno",
        attention: "Atención",
        criticalStatus: "Crítico",
      },
      quick: {
        title: "Acciones rápidas",
        subtitle: "Crear nuevo registro",
        close: "Cerrar",
        newEpp: "Nueva solicitud de EPP",
        newConsulta: "Nueva consulta médica",
        newRiesgo: "Nueva evaluación de riesgo",
        newPermiso: "Nuevo permiso de trabajo",
        newActo: "Nuevo acto o condición insegura",
      },
      notif: {
        title: "Notificaciones",
        desc: "Alertas de cumplimiento, vencimientos y eventos del sistema HSE",
        markAll: "Marcar todas leídas",
        empty: "No hay notificaciones",
        markedRead: "Notificaciones marcadas como leídas",
        markError: "No se pudieron marcar como leídas",
        unread: "No leída",
        justNow: "hace un momento",
        minsAgo: "hace {{n}} min",
        hoursAgo: "hace {{n}} h",
        daysAgo: "hace {{n}} d",
      },
      acuse: {
        ackedOn: "Acusaste de recibido el {{date}}",
        confirmRead: "Confirma que leíste y entendiste este documento.",
        registering: "Registrando…",
        ackButton: "Acuso de recibido",
        ackSuccess: "Acuse de recibido registrado. ¡Gracias!",
        ackError: "No se pudo registrar el acuse",
        tracking: "Seguimiento de acuse",
        acked: "Ya acusaron ({{n}})",
        noneYet: "Nadie aún",
        pending: "Pendientes ({{n}})",
        allUpToDate: "¡Todos al día! 🎉",
      },
      gami: {
        ranking: "Ranking HSE",
        levels: {
          "Aprendiz": "Aprendiz",
          "Bronce": "Bronce",
          "Plata": "Plata",
          "Oro": "Oro",
          "Platino": "Platino",
          "Diamante": "Diamante",
          "Maestro HSE": "Maestro HSE",
          "Leyenda HSE": "Leyenda HSE",
        },
      },
      offline: {
        online: "En línea",
        pendingUpload: "Pendientes por subir",
        noConnection: "Sin conexión",
        inQueue: "{{count}} registro(s) en cola",
        offlineMode: "Modo offline activo",
        syncing: "Sincronizando…",
        syncNow: "Sincronizar ahora",
      },
      plant: {
        plant: "Planta",
        active: "Planta activa",
        select: "Selecciona planta",
      },
      saludDash: {
        loading: "Cargando dashboard salud...",
        title: "Dashboard Salud Ocupacional",
        subtitle: "NOM-030 (Vigilancia) · NOM-036 (Ergonomía) · NOM-035 (Psicosocial) · DC-3",
        examsExpired: "Exámenes vencidos",
        notFit: "No aptos",
        ergoHigh: "Ergo Alto/Muy Alto",
        nom035High: "NOM-035 Alto",
        vigTotal: "Vigilancia (total)",
        fitRestr: "Apto c/ restricciones",
        ergoEvals: "Evaluaciones Ergo",
        trainingValid: "Capacitaciones vigentes",
        ergoByLevel: "Ergonomía por Nivel de Riesgo",
        noEvals: "Sin evaluaciones.",
        nom035ByLevel: "NOM-035 por Nivel de Riesgo Psicosocial",
        noQuestionnaires: "Sin cuestionarios.",
        lvlNulo: "Nulo", lvlBajo: "Bajo", lvlMedio: "Medio", lvlAlto: "Alto", lvlMuyAlto: "Muy Alto",
      },
      eppDash: {
        loading: "Cargando dashboard EPP...",
        noData: "Sin datos.",
        title: "Dashboard EPP",
        subtitle: "Gestión de Equipo de Protección Personal · LGMG",
        activeItems: "Ítems Activos",
        lowStock: "Stock Bajo",
        pendingReq: "Solicitudes Pendientes",
        expiring7d: "Por Vencer (7d)",
        expired: "Vencidos",
        movementsToday: "Movimientos Hoy",
        inventoryValue: "Valor Inventario",
        movByType: "Movimientos por Tipo (30d)",
        noMov30d: "Sin movimientos en los últimos 30 días.",
        consByArea: "Consumo por Área (30d)",
        noCons: "Sin consumo registrado.",
        lowStockItems: "Ítems en Stock Bajo",
        min: "Mín",
        typeEntry: "Entradas", typeExit: "Salidas", typeReplacement: "Reposición", typeAdjustment: "Ajustes",
      },
      ambDash: {
        loading: "Cargando dashboard ambiente...",
        title: "Dashboard Medio Ambiente",
        subtitle: "Residuos · Consumos · Huella de Carbono · Cumplimiento SEMARNAT",
        rpGenerated: "RP generados ({{year}})",
        rpYear: "Año RP",
        co2Year: "Huella CO₂ año actual",
        servicesCost: "Costo servicios año",
        permitsExpVenc: "Permisos vencidos / por vencer",
        rpTrend: "Tendencia Residuos Peligrosos ({{year}})",
        noDataResiduos: "Sin datos. Registra en /residuos.",
        consByType: "Consumos del Año por Tipo",
        noDataConsumos: "Sin datos. Registra en /consumos.",
        residuosByType: "Residuos por Tipo ({{year}})",
        noResiduos: "Sin residuos registrados.",
        colType: "Tipo", colQty: "Cantidad", colRecords: "Registros", colDeliveries: "Entregas",
        permitsExpiring: "Permisos Próximos a Vencer",
        noCriticalPermits: "Sin permisos críticos.",
        expires: "Vence",
        bitacoraByType: "Bitácora al Almacén por Tipo (12m)",
        noDeliveries: "Sin entregas registradas. Registra en /ambiente/bitacora-residuos.",
        noDeliveriesShort: "Sin entregas registradas.",
        bitacoraByArea: "Bitácora al Almacén por Área (12m)",
        tipoRP: "Peligrosos", tipoRME: "Manejo Especial", tipoRSU: "Sólidos Urbanos",
        consAgua: "Agua", consElectricidad: "Electricidad", consGasLp: "Gas LP", consGasNatural: "Gas Natural", consDiesel: "Diesel", consGasolina: "Gasolina",
      },
      // ===== Training (Plan Anual / Asistencias) =====
      training: {
        section: "Capacitación",
        planAnnualTitle: "Plan Anual",
        planAnnualSubtitle: "Cursos previstos por NOM y área",
        attendanceTitle: "Asistencias",
        attendanceSubtitle: "Check-in masivo por sesión",
        newCourse: "Nuevo curso",
        newSession: "Nueva sesión",
        totalCourses: "Total cursos",
        completed: "Completadas",
        ongoing: "En curso",
        executedHours: "Horas ejecutadas",
        peopleTrained: "Personas capacitadas",
        progress: "% Avance",
        coursesIn: "{{count}} curso(s)",
        noCoursesPlanned: "Sin cursos planeados",
        sessions: "{{count}} sesión(es)",
        hExec: "{{h}}h ejec",
        people: "{{n}} personas",
        status: {
          planeada: "Planeada",
          en_curso: "En curso",
          completada: "Completada",
          cancelada: "Cancelada",
        },
        // session form
        title: "Título",
        instructor: "Instructor",
        nomOptional: "NOM (opcional)",
        startTime: "Hora inicio",
        endTime: "Hora fin",
        durationH: "Duración (h)",
        location: "Ubicación",
        notes: "Observaciones",
        linkToPlan: "Vincular con Plan Anual (opcional)",
        noLink: "— Sin vínculo —",
        linkHint: "Al vincular, el plan pasa a \"en curso\" y la sesión cuenta en su avance.",
        createAndCapture: "Crear y capturar",
        // attendees
        checkin: "Check-in",
        importList: "Importar lista (pega desde Excel)",
        importPlaceholder: "Nombre, ID, CURP, Área, Puesto (un asistente por línea)\nEj: Juan Pérez, EMP-001, PEJU890101HDFRRN02, Soldadura, Soldador",
        importLines: "Importar {{n}} línea(s)",
        present: "presentes",
        markAll: "Marcar todos",
        clearAll: "Limpiar",
        addRow: "Fila",
        saveAttendance: "Guardar asistencias",
        empty: "Sin asistentes. Importa una lista o agrega filas manualmente.",
        noSessions: "Sin sesiones registradas para {{year}}",
        // DC-3 bulk
        dc3Bulk: "DC-3 masivo",
        dc3BulkTitle: "Generar DC-3 masivo",
        dc3BulkInfo: "{{n}} asistente(s) firmado(s) con CURP — se generará un PDF para cada uno.",
        dc3BulkWarn: "{{n}} firmado(s) sin CURP serán omitidos. Captura la CURP en el check-in para incluirlos.",
        dc3CompanyData: "Datos de la empresa",
        legalName: "Razón social",
        rfc: "RFC",
        activity: "Actividad económica",
        address: "Domicilio",
        trainerCurp: "CURP instructor",
        stpsRegistration: "Registro STPS",
        course: "Curso",
        thematicArea: "Área temática",
        modality: "Modalidad",
        employerRep: "Representante del patrón",
        position: "Puesto",
        downloadZip: "Descargar {{n}} DC-3 (ZIP)",
        generatingZip: "Generando ZIP…",
      },
      // ===== Seguridad =====
      seg: {
        loading: "Cargando…", cancel: "Cancelar", create: "Crear", creating: "Creando…",
        view: "Ver →", newInspection: "Nueva Inspección",
        ip: {
          title: "Inspecciones de Planta",
          subtitle: "Recorrido de seguridad por las 21 categorías de planta · Matriz 5×5 · CAPA automáticas",
          kTotal: "Recorridos totales", kCompliance: "Cumplimiento promedio",
          kNoCumple: "No conformidades", kCritical: "Hallazgos críticos (Alto/Extremo)",
          thFecha: "Fecha", thFolio: "Folio", thArea: "Área / Zona", thInspector: "Inspector",
          thCumplimiento: "Cumplimiento", thNoCumple: "No Cumple", thCriticos: "Críticos", thCapas: "CAPAs",
          empty: "Aún no hay inspecciones de planta. Crea la primera para comenzar.",
        },
        nomi: {
          title: "Inspecciones NOM STPS",
          subtitle: "Checklists oficiales con matriz 5×5, evidencia fotográfica y CAPA automáticas",
          kTotal: "Inspecciones totales", kCompliance: "Cumplimiento promedio",
          kNoCumple: "No conformidades", kCritical: "Hallazgos críticos (Alto/Extremo)",
          thFecha: "Fecha", thNom: "NOM", thArea: "Área", thInspector: "Inspector",
          thCumplimiento: "Cumplimiento", thNoCumple: "No Cumple", thCriticos: "Críticos", thCapas: "CAPAs",
          empty: "Aún no hay inspecciones. Crea la primera para comenzar.",
        },
        proc: {
          title: "Procedimientos Estándar de Seguridad",
          subtitle: "Un procedimiento por cada Norma STPS, con los puntos más relevantes y firma de Supervisor y Gerente.",
          newBtn: "Nuevo Procedimiento",
          searchPh: "Buscar por NOM, título o autor...",
          fAll: "Todos",
          noResults: "No se encontraron procedimientos que coincidan con la búsqueda.",
          emptyList: "No hay procedimientos.",
          stSinRedactar: "Sin redactar", stAutorizado: "Autorizado", stPendiente: "Pendiente de firma",
          loadErr: "No se pudieron cargar los procedimientos",
          confirmDelCustom: "¿Eliminar el procedimiento \"{{name}}\"? Esta acción no se puede deshacer.",
          confirmDelNom: "¿Eliminar el contenido y las firmas de {{name}}? La tarjeta permanecerá pero quedará en blanco (\"Sin redactar\").",
          delCustomOk: "Procedimiento eliminado", delNomOk: "Contenido eliminado", delErr: "No se pudo eliminar",
          delTitle: "Eliminar", editedBy: "Editado por {{name}}", custom: "Personalizado",
          newTitle: "Nuevo Procedimiento", fTitulo: "Título", fTituloPh: "Ej. Bloqueo y etiquetado interno (LOTO)",
          fCodigo: "Código / Referencia (opcional)", fCodigoPh: "Ej. PRO-INT-01",
          fCodigoHint: "Si lo dejas vacío se asigna un código automático.",
          needTitle: "Escribe un título", createdOk: "Procedimiento creado", createErr: "No se pudo crear",
        },
        pd: {
          back: "Volver a Procedimientos", loadErr: "No se pudo cargar el procedimiento",
          loadingProc: "Cargando procedimiento…", notFound: "No encontrado",
          s1: "1. Objetivo", s2: "2. Alcance", s3: "3. Responsabilidades", s4: "4. Desarrollo",
          s5: "5. EPP requerido", s6: "6. Referencias normativas",
          autorizado: "AUTORIZADO", pendiente: "PENDIENTE DE AUTORIZACIÓN",
          generando: "Generando…", regenerarIA: "Regenerar con IA", generarBorradorIA: "Generar borrador (IA)",
          editar: "Editar", editarEncabezado: "Editar encabezado", eliminar: "Eliminar",
          confirmRegen: "El procedimiento está autorizado. Regenerar reiniciará las firmas. ¿Continuar?",
          borradorGen: "Borrador generado con IA", borradorGenReset: "Borrador generado. Se reiniciaron las firmas.",
          genErr: "No se pudo generar el borrador",
          emptyMsg: "Este procedimiento aún no tiene contenido.", generarConIA: "Generar borrador con IA",
          tituloProc: "Título del procedimiento", codigoRef: "Código / Referencia (NOM)", codigoPh: "Ej. NOM-004-STPS-1999",
          unElemPorLinea: "Un elemento por línea", escribeUnElem: "Escribe un elemento por línea.",
          guardar: "Guardar", guardando: "Guardando…", cancelar: "Cancelar",
          savedOk: "Procedimiento guardado", savedReset: "Contenido editado. Se reiniciaron las firmas; debe re-autorizarse.",
          saveErr: "No se pudo guardar",
          noAutorizadoNota: "Este procedimiento no está autorizado hasta contar con la firma de Supervisor y Gerente.",
          sinContenido: "Sin contenido",
          confirmDelCustom: "¿Eliminar este procedimiento personalizado? Esta acción no se puede deshacer.",
          confirmDelNom: "¿Eliminar el contenido y las firmas de {{name}}? El procedimiento quedará en blanco (\"Sin redactar\").",
          delOk: "Procedimiento eliminado", delContentOk: "Contenido eliminado", delErr: "No se pudo eliminar",
          pdfErr: "No se pudo descargar el PDF",
          evidencias: "Evidencias / Anexos", foto: "Foto", documento: "Documento", subiendo: "Subiendo…",
          sinEvidencias: "Sin evidencias adjuntas. Puedes anexar el procedimiento firmado, fotos o diagramas.",
          evAdjuntada: "Evidencia adjuntada", evErr: "No se pudo subir el archivo",
          confirmDelEv: "¿Eliminar esta evidencia?", evDelOk: "Evidencia eliminada", evDelErr: "No se pudo eliminar",
        },
        norma: {
          est_pendiente_evidencia: "Pendiente evidencia", est_pendiente_supervisor: "En supervisor",
          est_pendiente_gerente: "En gerente", est_cumple: "Cumple", est_no_cumple: "No cumple",
          firmaDigital: "Firma digital", limpiar: "Limpiar",
          autorizacion: "Autorización", autorizacionHint: "Firman de conformidad tras la revisión de esta NOM.",
          rol_auditor: "Auditor", rol_supervisorEhs: "Supervisor de EHS", rol_gerenteArea: "Gerente de Área",
          refirmar: "Volver a firmar", firmarTitulo: "Firmar como", nombreCompleto: "Nombre completo",
          firmar: "Firmar",
          comentarioOpcional: "Comentario (opcional)", nombreReq: "El nombre es obligatorio",
          firmaGuardada: "Firma registrada",
          medicion: "Medición / dato (opcional)", medicionPh: "Ej: \"320 lux\", \"32 °C\", \"Cumple GHS\"",
          notaDesc: "Nota descriptiva", notaPh: "Describe lo observado...",
          frecReeval: "Frecuencia de re-evaluación (meses)", mes: "mes", meses: "meses",
          fotos15: "Fotos (1–5) *", fotosSel: "{{n}} foto(s) seleccionada(s)",
          selAreaErr: "Selecciona el área", sube1: "Sube al menos 1 foto", max5: "Máximo 5 fotos",
          evEnviada: "Evidencia enviada al supervisor", evErr: "Error al enviar evidencia",
          enviando: "Enviando...", enviarSup: "Enviar al supervisor", cancelar: "Cancelar",
          vSupTitle: "Verificación de Supervisor (paso 2/3)", vGerTitle: "Validación de Gerente (paso 3/3)",
          evPresentada: "Evidencia presentada", medicionB: "Medición:", notaB: "Nota:",
          motivoOblig: "El motivo del rechazo es obligatorio", firmaReqAprobar: "Firma requerida para aprobar",
          capaGen: "CAPA Alto generada automáticamente", aprobado: "Aprobado", rechazadoResp: "Rechazado, regresa al responsable",
          errProcesar: "Error al procesar", decision: "Decisión", aprobar: "Aprobar", rechazar: "Rechazar",
          motivoRechazo: "Motivo del rechazo (obligatorio)", comentario: "Comentario",
          notaGerRechazo: "Si rechazas, se generará automáticamente una CAPA Alto con plazo de 30 días.",
          notaSupRechazo: "El registro regresará al responsable para nueva evidencia.",
          procesando: "Procesando...", firmarAprobar: "Firmar y aprobar", confirmarRechazo: "Confirmar rechazo",
          loadErr: "No se pudieron cargar los datos", pdfOk: "PDF descargado", pdfErr: "Error al generar PDF",
          loading: "Cargando…", nomNotFound: "NOM no encontrada.", volver: "Volver",
          cumplimientoPorNorma: "Cumplimiento por Norma", cumplimientoGlobal: "Cumplimiento global", exportarPdf: "Exportar PDF",
          requisitos: "Requisitos", cumpleK: "Cumple", noCumpleK: "No cumple", pendientesK: "Pendientes",
          area: "Área:", medicionL: "Medición:", frec: "Frec.: cada {{n}} m", proxRev: "Próx. revisión:",
          verificarSup: "Verificar (Supervisor)", validarGer: "Validar (Gerente)", nuevaEvidencia: "Nueva evidencia",
          supervisorB: "Supervisor:", gerenteB: "Gerente:", aprobadoT: "Aprobado", rechazadoT: "Rechazado", validadoT: "Validado",
          capaAltoGen: "CAPA Alto generada · ID {{id}}…",
        },
        det: {
          backToList: "Volver al listado", notFound: "Inspección no encontrada",
          area: "Área", inspector: "Inspector", fecha: "Fecha",
          compliance: "Cumplimiento", downloadPdf: "Descargar PDF",
          cumple: "Cumple", noCumple: "No cumple", noAplica: "No aplica", criticos: "Críticos (Alto/Extremo)",
          estCumple: "Cumple", estNoCumple: "No cumple", estNoAplica: "No aplica",
          matriz5x5: "Matriz 5×5:", notas: "Notas:", capaAuto: "→ CAPA auto-generada (ver tabla abajo)",
          jsaAuto: "Acciones JSA auto-generadas ({{n}})",
          thReq: "Req.", thCategoria: "Categoría", thHallazgo: "Hallazgo", thNivel: "Nivel",
          thPlazo: "Plazo", thResponsable: "Responsable", thEstado: "Estado",
          porAsignar: "Por asignar",
          plazosAuto: "Plazos automáticos: Extremo 7 días · Alto 30 días · Medio 60 días · Bajo 90 días",
          verTodasCapas: "Ver todas las CAPAs →", obsGenerales: "Observaciones generales",
          resultadosReq: "Resultados por requisito", requisito: "Requisito {{n}}",
          resultadosCat: "Resultados por categoría", inspPlantaSub: "Inspección de Planta — Recorrido de seguridad",
          firmasTitle: "Firmas de autorización", autorizada: "AUTORIZADA",
          supervisorEhs: "Supervisor EHS", gerenteOperacion: "Gerente Operación",
          firmaDe: "Firma {{label}}", firmar: "Firmar", pendienteFirma: "Pendiente de firma",
          firmasNote: "Cada quien firma desde su propia cuenta: el Supervisor EHS y el Gerente Operación. La inspección queda AUTORIZADA con ambas firmas.",
          captureSign: "Captura la firma antes de guardar", signSaved: "Firma guardada", signErr: "No se pudo firmar",
          firmarComo: "Firmar como {{label}}", nombreFirma: "Nombre de quien firma", trazarFirma: "Trazar firma",
          guardarFirma: "Guardar firma", guardando: "Guardando…",
          nivel_Bajo: "Bajo", nivel_Medio: "Medio", nivel_Alto: "Alto", nivel_Extremo: "Extremo",
          capa_abierta: "abierta", capa_cerrada: "cerrada", capa_en_proceso: "en proceso",
        },
        nueva: {
          ipTitle: "Nueva Inspección de Planta", ipSub: "21 categorías · Matriz 5×5 · CAPA automática para \"No cumple\"",
          nomTitle: "Nueva Inspección NOM", nomSub: "Checklist oficial · Matriz 5×5 · CAPA automática para \"No cumple\"",
          areaZona: "Área / Zona inspeccionada *", areaZonaPh: "Ej. Patio de maniobras, Nave 1",
          inspector: "Inspector *", inspectorPh: "Nombre del inspector", inspectorPhNom: "Nombre del auditor",
          normaStps: "Norma STPS *", selNom: "Selecciona NOM", areaInsp: "Área inspeccionada *", selArea: "Selecciona área",
          catEval: "Categorías de evaluación", categorias: "{{n}} categorías", items: "{{n}} ítems",
          cambiar: "Cambiar", definirMatriz: "Definir matriz",
          adjuntarFoto: "Adjuntar foto", subiendo: "Subiendo…", fotos: "{{n}} foto(s)",
          notasPh: "Notas / detalle del hallazgo",
          guardar: "Guardar inspección y generar CAPAs", guardando: "Guardando…",
          matrizTitle: "Matriz de Riesgo 5×5",
          matrizDesc: "Define la probabilidad y la severidad del hallazgo para calcular el nivel de riesgo.",
          probLabel: "Probabilidad (1=Rara · 5=Casi cierta)", sevLabel: "Severidad (1=Insignificante · 5=Catastrófica)",
          nivel: "Nivel: {{n}}", confirmar: "Confirmar",
          fotoCargada: "Foto cargada", fotoErr: "Error al subir la foto",
          reqAreaInsp: "Completa Área/Zona e Inspector", reqNomArea: "Completa NOM, área e inspector",
          faltanCat: "Faltan {{n}} categoría(s) por evaluar", faltanItems: "Faltan {{n}} ítem(s) por responder",
          faltanMatriz: "Hay {{n}} hallazgo(s) \"No cumple\" sin matriz 5×5",
          inspRegistrada: "Inspección registrada • {{n}} CAPA auto-generadas", inspErr: "Error al crear la inspección",
        },
        capas: {
          title: "Administración JSA",
          subtitle: "Acciones correctivas auto-creadas desde inspecciones NOM, vigilancia médica (No apto), ergonomía (Muy alto) y NOM-035 (atención clínica)",
          estado: "Estado", todos: "Todos", abierta: "Abierta", enProgreso: "En progreso", cerrada: "Cerrada",
          nivelRiesgo: "Nivel de riesgo", origen: "Origen",
          inspNom: "Inspecciones NOM", vigMedica: "Vigilancia Médica", ergonomia: "Ergonomía", psicosocial: "NOM-035 Psicosocial",
          srcNom: "Inspección NOM",
          reporteSeguridad: "Reporte de Seguridad",
          thOrigen: "Origen", thNom: "NOM", thReq: "Req.", thHallazgo: "Hallazgo", thArea: "Área",
          thNivel: "Nivel", thFechaGen: "Fecha generación", thPlazo: "Plazo", thResponsable: "Responsable", thEstado: "Estado",
          emptyFiltered: "Sin CAPAs con los filtros aplicados.",
          editar: "Editar", editTitle: "Editar acción JSA",
          responsable: "Responsable", email: "Email", fechaLimite: "Fecha límite",
          urlEvidencia: "URL evidencia de cierre", comentariosCierre: "Comentarios de cierre",
          cancelar: "Cancelar", guardar: "Guardar",
          noExport: "No hay CAPAs para exportar", excelOk: "Excel descargado", pdfOk: "PDF descargado",
          noReport: "No hay CAPAs para el reporte", reportOk: "Reporte de Seguridad descargado",
          capaSaved: "CAPA actualizada", saveErr: "Error al guardar",
          est_abierta: "abierta", est_en_progreso: "en progreso", est_cerrada: "cerrada",
        },
        acto: {
          title: "Actos y Condiciones Inseguras", subtitle: "Tarjetas de observación de seguridad conductual.",
          semana: "Semana", todasSemanas: "Todas las semanas", semanaN: "Semana {{n}} · {{range}} ({{c}})",
          generando: "Generando…", descargarPdf: "Descargar PDF", nuevaTarjeta: "Nueva tarjeta",
          tipo: "Tipo", todos: "Todos", actoInseguro: "Acto Inseguro", condicionInsegura: "Condición Insegura",
          estatus: "Estatus", abiertas: "Abiertas", cerradas: "Cerradas",
          loading: "Cargando…", emptyFiltered: "No hay tarjetas con los filtros aplicados.",
          riesgo: "Riesgo {{n}}", cerrada: "Cerrada", abierta: "Abierta", notificado: "Notificado",
          turno: "Turno {{n}}", accion: "Acción:", recomendaciones: "Recomendaciones:",
          responsableL: "Responsable: {{n}}", sinResponsable: "Sin responsable",
          enviarCorreo: "Enviar correo", reabrir: "Reabrir", cerrar: "Cerrar",
          editarTarjeta: "Editar tarjeta", nuevaTarjetaT: "Nueva tarjeta",
          tipoReq: "Tipo *", areaReq: "Área *", selArea: "Selecciona área", nivelRiesgo: "Nivel de riesgo",
          turnoL: "Turno", turnoPh: "Matutino / Vespertino / Nocturno",
          descObs: "Descripción de la observación *", recomendacionesL: "Recomendaciones", accionCorrectiva: "Acción correctiva",
          responsableCierre: "Responsable de cierre", correoResp: "Correo del responsable", correoPh: "responsable@empresa.com",
          reportadoPor: "Reportado por", fecha: "Fecha", fotoOpcional: "Fotografía (opcional)", subir: "Subir", tomarFoto: "Tomar foto",
          cancelar: "Cancelar", guardando: "Guardando…", guardarCambios: "Guardar cambios", registrar: "Registrar",
          loadErr: "Error al cargar las tarjetas", fotoAgregada: "Foto agregada", fotoErr: "Error al subir la foto",
          selAreaErr: "Selecciona un área", descObsErr: "Describe la observación",
          tarjetaActualizada: "Tarjeta actualizada", tarjetaRegistrada: "Tarjeta registrada", saveErr: "Error al guardar",
          tarjetaCerrada: "Tarjeta cerrada", tarjetaReabierta: "Tarjeta reabierta", err: "Error",
          sinCorreo: "Esta tarjeta no tiene correo de responsable. Edítala para agregarlo.",
          correoEnviado: "Correo enviado a {{email}}", correoErr: "Error al enviar correo",
          confirmDelete: "¿Eliminar esta tarjeta?", tarjetaEliminada: "Tarjeta eliminada", delErr: "Error al eliminar",
          nivel_bajo: "Bajo", nivel_medio: "Medio", nivel_alto: "Alto", nivel_critico: "Crítico",
          filtroArea: "Área", todasAreas: "Todas las áreas", filtroNombre: "Nombre",
          filtroNombrePh: "Reportado por / Responsable", limpiarFiltros: "Limpiar",
          fundamentoLegal: "Fundamento Legal (NOM)", causaEfecto: "Causa-Efecto",
          sugerirIA: "Sugerir con IA", sugiriendo: "Sugiriendo…",
          iaOk: "Sugerencia aplicada. Revísala antes de guardar.", iaErr: "No se pudo generar la sugerencia",
          descIAErr: "Escribe primero la descripción del hallazgo",
          noData: "No hay tarjetas para el reporte", nivel: "Nivel",
          enviarReporte: "Enviar por correo", enviarReporteT: "Enviar Reporte de Seguridad por correo",
          destinatarios: "Destinatarios (separa con comas)", destinatariosOpc: "Destinatarios (opcional, para enviar por correo)",
          correoDestErr: "Ingresa al menos un correo válido", idiomaReporte: "Idioma del reporte",
          enviando: "Enviando…", enviarPdf: "Enviar PDF", reporteTarjetas: "Tarjetas incluidas",
          reporteEnviado: "Enviado a {{n}} destinatario(s)", reporteNoEnviado: "No se pudo enviar el correo",
          reporteErr: "Error al enviar el reporte",
          recorridoCsh: "Recorrido CSH", recorridoT: "Datos del Recorrido — Comisión de Seguridad e Higiene",
          recorridoNota: "Se incluirán las tarjetas actualmente filtradas", generarPdf: "Generar PDF",
          recorridoOk: "Recorrido CSH descargado", recorridoErr: "Error al generar el Recorrido CSH",
          recFecha: "Fecha", recRazon: "a) Nombre o Razón Social", recTrab: "b) N° de Trabajadores",
          recDom: "c) Domicilio Completo", recTipoVer: "d) Tipo de Verificación", recFolio: "Folio",
          recHini: "e) Hora de Inicio", recHfin: "Hora de Finalización",
          ordinario: "Ordinario", extraordinario: "Extraordinario",
          historial: "Historial", historialT: "Historial de Recorridos CSH",
          historialVacio: "Aún no hay recorridos guardados. Genera o envía un Recorrido CSH para verlo aquí.",
          reimprimir: "Reimprimir", hallazgos: "hallazgos", cierrePct: "% cierre", enviadoA: "Enviado a",
          pdfFirmado: "PDF firmado", pdfFirmadoErr: "No se pudo descargar el PDF firmado",
          evidenciaFirmada: "Evidencia firmada disponible",
          soloFirmados: "Solo firmados", pendientesFirma: "Pendientes de firma",
          historialSinFiltro: "No hay recorridos que coincidan con el filtro.",
          firmadosLbl: "firmados", pendientesLbl: "pendientes",
          zipFirmados: "ZIP de firmados", zipErr: "No se pudo descargar el ZIP de firmados",
          faltantesIA: "{{n}} tarjeta(s) sin Fundamento Legal o Causa-Efecto",
          rellenarIA: "Rellenar faltantes con IA", rellenando: "Completando…",
          rellenadoIA: "IA completó {{n}} tarjeta(s)", sinFaltantes: "Todas las tarjetas ya tienen Fundamento Legal y Causa-Efecto",
          solicitarFirmas: "Firmas", solicitarFirmasT: "Solicitar firmas digitales",
          solicitarFirmasDesc: "Cada firmante recibirá un correo con un enlace único para firmar desde su celular o computadora. La firma quedará sellada con fecha y hora.",
          enviarSolicitud: "Enviar solicitud", firmaCorreoErr: "Ingresa al menos un correo válido",
          firmaErr: "No se pudo enviar la solicitud de firmas", firmasEnviadas: "Solicitud enviada a {{n}} firmante(s)",
          firmado: "Firmado", pendiente: "Pendiente", firmadoCerrado: "Firmado / Cerrado",
          firmasLabel: "Firmas", nombrePh: "Nombre", correoEmpresaPh: "correo@empresa.com",
        },
      },
      // ===== Administración (Permisos, Auditoría, Empresas, Super Admin) =====
      admin: {
        loading: "Cargando...", cancel: "Cancelar", save: "Guardar", refresh: "Refrescar",
        act: { read: "Ver", create: "Crear", edit: "Editar", delete: "Eliminar", approve: "Aprobar", deliver: "Entregar" },
        rolAll: "Todos",
        perm: {
          title: "Administración de Permisos",
          subtitle: "Matriz dinámica de roles × módulos × acciones (ISO 45001 · 5.3)",
          auditBtn: "Auditoría", resetBtn: "Restaurar defaults", save: "Guardar", noPending: "Sin cambios pendientes",
          savedSuffix: "guardado",
          confirmReset: "¿Restaurar TODA la matriz a valores por defecto? Se borrarán los permisos personalizados.",
          restored: "Matriz restaurada", loadingMatrix: "Cargando matriz de permisos...",
          infoMain: "Cada celda controla qué acciones puede ejecutar un rol en cada módulo. Los cambios surten efecto inmediato (cache 30s). Toda modificación se registra en Auditoría.",
          infoActions: "Acciones: read=ver, create=crear, edit=editar, delete=eliminar, approve=aprobar/rechazar, deliver=entregar (EPP almacén).",
          colModule: "Módulo", saveCell: "Guardar",
        },
        audit: {
          title: "Auditoría de Permisos",
          subtitle: "Historial cronológico de cambios en la matriz de permisos",
          back: "Volver", loading: "Cargando...", empty: "Sin cambios registrados",
          thFecha: "Fecha", thUsuario: "Usuario", thRol: "Rol", thModulo: "Módulo", thAntes: "Antes", thDespues: "Después",
          resetGlobal: "Reset global",
        },
        emp: {
          title: "Gestión de Empresas",
          subtitle: "Alta y administración de empresas (multi-empresa). Cada empresa queda aislada en su propia carpeta dentro de la base de datos; una empresa nunca ve la información de otra.",
          newTitle: "Nueva empresa", nameLabel: "Nombre de la empresa", namePh: "Ej. AvilesSafety",
          createBtn: "Crear empresa", creating: "Creando…",
          nameMin: "El nombre debe tener al menos 2 caracteres",
          createdToast: "Empresa \"{{name}}\" creada", createErr: "Error al crear la empresa", loadErr: "Error al cargar empresas",
          confirmDelete: "¿Eliminar la empresa \"{{name}}\"? Se borrarán todos sus datos de forma permanente.",
          deletedToast: "Empresa \"{{name}}\" eliminada", deleteErr: "Error al eliminar la empresa",
          registered: "Empresas registradas ({{n}})", loadingList: "Cargando…", noneRegistered: "No hay empresas registradas.",
          principal: "Principal", active: "Activa",
          markPrincipal: "Marcar principal", createGerente: "Crear Gerente", customize: "Personalizar",
          administering: "Administrando", administer: "Administrar",
          confirmPrincipal: "¿Marcar \"{{name}}\" como empresa principal (por defecto)?",
          principalToast: "\"{{name}}\" es ahora la empresa principal", principalErr: "Error al definir la empresa principal",
          footer: "Al pulsar Administrar el sistema cambia la empresa activa y recarga para que todos los datos (usuarios, inspecciones, reportes) correspondan a esa empresa.",
          brandTitle: "Personalizar marca — {{name}}", brandColor: "Color de marca", brandPreview: "Vista previa",
          brandColorHint: "Formato HEX (#RRGGBB). Solo afecta a esta empresa.",
          brandLogo: "Logo de la empresa", uploadLogo: "Subir logo", uploading: "Subiendo…",
          logoUploaded: "Logo subido", logoErr: "Error al subir el logo",
          brandLogoWarn: "⚠️ Para que el logo se muestre correctamente, primero pulsa Administrar en esta empresa y luego súbelo.",
          saveBrand: "Guardar marca", savingBrand: "Guardando…",
          brandSaved: "Marca actualizada para \"{{name}}\"", brandErr: "Error al guardar la marca",
          gerenteTitle: "Crear Gerente — {{name}}", gFullName: "Nombre completo", gNamePh: "Ej. Juan Pérez",
          gEmail: "Correo", gEmailPh: "gerente@empresa.com", gPassword: "Contraseña temporal", gPasswordPh: "Mínimo 12 caracteres",
          gPasswordHint: "Mínimo 12 caracteres, con mayúscula, minúscula, número y símbolo. El gerente deberá cambiarla en su primer ingreso.",
          gNameMin: "Ingresa el nombre del gerente", gCreatedToast: "Gerente creado para \"{{name}}\"", gErr: "Error al crear el gerente",
          isoBtn: "Probar aislamiento", isoTitle: "Prueba de aislamiento — {{name}}",
          isoRunning: "Ejecutando prueba de aislamiento…", isoErr: "Error al ejecutar la prueba de aislamiento",
          isoPass: "Aislamiento correcto", isoPassSub: "Esta empresa está completamente separada; ninguna otra empresa puede ver sus datos.",
          isoFail: "¡Posible fuga de datos!", isoFailSub: "El marcador fue visible desde otra empresa. Revisa la configuración antes de usar en producción.",
          isoType: "Tipo de aislamiento", isoNamespace: "Carpeta / Namespace", isoVisible: "Marcador visible en su carpeta",
          isoOthersChecked: "Otras empresas revisadas", isoLeaks: "Fugas detectadas", isoNoLeaks: "Ninguna",
          isoYes: "Sí", isoNo: "No", isoRerun: "Volver a probar",
          sanitizeBtn: "Sanear datos LGMG", sanitizing: "Saneando…",
          sanitizeConfirm: "Corregirá datos de la empresa principal (LGMG) que se hayan copiado a OTRAS empresas: responsables del Programa de Seguimiento → \"Por asignar\" y elimina las Áreas de Planta por defecto de LGMG. No afecta datos propios de cada empresa. ¿Continuar?",
          sanitizeDone: "Saneamiento completado: {{n}} responsable(s) y {{a}} área(s) corregidas",
          sanitizeNone: "Todo en orden: no había datos de LGMG por sanear",
          sanitizeErr: "Error al ejecutar el saneamiento",
        },
        sa: {
          kicker: "Super Admin", title: "Control de accesos",
          subtitle: "Visibilidad de menú y submenús por rol",
          resetDefault: "Restaurar default", saving: "Guardando…", saveChanges: "Guardar cambios", noChanges: "Sin cambios",
          tabMenu: "Visibilidad de menú", tabUsers: "Usuarios y bloqueos",
          loadMatrixErr: "Error al cargar matriz de menú", loadUsersErr: "Error al cargar usuarios",
          accessDenied: "Acceso denegado", accessDeniedMsg: "Esta sección está reservada al Super Admin.", loading: "Cargando…",
          gerenteAlways: "El Gerente siempre tiene acceso total",
          changesSaved: "Cambios guardados", saveErr: "Error al guardar",
          confirmReset: "¿Restaurar visibilidad por defecto para todos los roles?", resetDone: "Restaurado a valores por defecto", resetErr: "Error al restaurar",
          quickPermTitle: "Permisos CRUD", quickPermSub: "Ver / crear / editar / eliminar por módulo",
          quickAuditTitle: "Auditoría", quickAuditSub: "Historial de cambios de permisos",
          quickUsersTitle: "Usuarios", quickUsersSub: "Crear / asignar roles a personal",
          gerenteFullNote: "El rol Gerente siempre tiene acceso total al sistema. No es posible restringir.",
          removeAll: "Quitar todos", activateAll: "Activar todos",
          unsavedBanner: "Tienes cambios sin guardar", saveBtn: "Guardar",
          loadingUsers: "Cargando usuarios…",
          confirmLock: "¿{{verb}} a {{name}} ({{email}})?", verbLock: "bloquear", verbUnlock: "desbloquear",
          userLocked: "Usuario bloqueado", userUnlocked: "Usuario desbloqueado", err: "Error",
          deleteKeyword: "ELIMINAR",
          deletePrompt: "⚠ ELIMINAR a {{name}} ({{email}}) es PERMANENTE.\nEscribe ELIMINAR para confirmar:",
          deleteCancel: "Cancelado — debes escribir ELIMINAR", userDeleted: "Usuario eliminado", deleteErr: "Error al eliminar",
          usersCount: "Usuarios ({{n}})",
          gerenteNote: "Como Gerente puedes bloquear/desbloquear supervisores, almacén y usuarios. Sólo el Super Admin puede bloquear a otro Gerente.",
          thUser: "Usuario", thRole: "Rol", thArea: "Área", thStatus: "Estado", thActions: "Acciones",
          stActive: "Activo", stLocked: "Bloqueado", lockedBy: "por {{name}}",
          btnLock: "Bloquear", btnUnlock: "Desbloquear",
          whySelf: "Tú mismo", whySuper: "Protegido (Super)", whyGerente: "Sólo Super Admin puede bloquear Gerentes",
          deleteTitle: "Eliminar usuario permanentemente",
        },
      },
      // ===== Medio Ambiente (Residuos, Consumos, Cumplimiento, Bitácora, Pases) =====
      amb: {
        loading: "Cargando...", save: "Guardar", cancel: "Cancelar", saving: "Guardando...",
        register: "Registrar", allTypes: "Todos los tipos", close: "Cerrar",
        res: {
          title: "Gestión de Residuos",
          subtitle: "Bitácora de residuos peligrosos, manejo especial y sólidos urbanos (LGEEPA · NOM-052-SEMARNAT)",
          addBtn: "Registrar Residuo",
          tipoRP: "Peligroso (RP)", tipoRME: "Manejo Especial (RME)", tipoRSU: "Sólido Urbano (RSU)",
          records: "registros",
          thFecha: "Fecha", thTipo: "Tipo", thResiduo: "Residuo", thClave: "Clave SEMARNAT",
          thCretib: "CRETIB", thArea: "Área", thCantidad: "Cantidad", thManifiesto: "Manifiesto",
          thDestino: "Destino", thEstatus: "Estatus",
          empty: "Sin residuos registrados", genFrom: "Generado desde {{folio}}", bitacora: "Bitácora",
          formTitle: "Registrar Residuo",
          fTipo: "Tipo", fFechaGen: "Fecha generación", fNombre: "Nombre del residuo",
          fNombrePh: "Ej. Estopa impregnada con solventes",
          fClave: "Clave SEMARNAT", fClavePh: "Ej. RP-04/02", fCretib: "CRETIB",
          fArea: "Área generadora", fCantidad: "Cantidad", fUnidad: "Unidad",
          secManifiesto: "Manifiesto y Disposición",
          fAlmacen: "Almacén temporal", fAlmacenPh: "Ubicación interna", fDisposicion: "Disposición",
          dispAlmacen: "Almacén temporal", dispTransporte: "En transporte", dispDispuesto: "Dispuesto final",
          fManifiesto: "Número manifiesto", fManifiestoPh: "Manifiesto SEMARNAT",
          fFechaDisp: "Fecha de disposición", fTransportista: "Transportista autorizado",
          fAutTrans: "# Autorización transportista", fDestino: "Destino final", fDestinoPh: "Empresa receptora",
          fAutDestino: "# Autorización destino", fCosto: "Costo de disposición", fObs: "Observaciones",
          toastSaved: "Residuo registrado",
        },
        cons: {
          title: "Consumos",
          subtitle: "Registro mensual de consumo, costo y huella de carbono (factor SEMARNAT/INECC)",
          addBtn: "Registrar Consumo",
          kAnio: "Consumo Año Actual", kCosto: "Costo Año Actual", kCo2: "Huella CO₂e Año",
          serie: "Serie histórica", serieEmpty: "Sin datos. Registra al menos un periodo.",
          consumoLeg: "Consumo ({{u}})",
          thPeriodo: "Periodo", thMedidor: "Medidor", thArea: "Área", thConsumo: "Consumo",
          thCosto: "Costo", thCo2: "CO₂e", thObs: "Observaciones", empty: "Sin registros",
          formTitle: "Registrar Consumo",
          fTipo: "Tipo", fPeriodo: "Periodo (YYYY-MM)", fMedidor: "Medidor / Cuenta",
          fMedidorPh: "Ej. CFE-12345", fArea: "Área", fAreaPh: "Planta / Oficinas",
          fConsumo: "Consumo", fUnidad: "Unidad", fCosto: "Costo", fObs: "Observaciones",
          toastSaved: "Consumo registrado",
          tAgua: "Agua", tElectricidad: "Electricidad", tGasLp: "Gas LP", tGasNatural: "Gas Natural", tDiesel: "Diesel", tGasolina: "Gasolina",
        },
        cump: {
          title: "Cumplimiento Ambiental",
          subtitle: "Permisos, licencias y obligaciones ante SEMARNAT, CONAGUA, PROFEPA",
          addBtn: "Nuevo Permiso",
          kVigentes: "Vigentes", kPorVencer: "Por vencer (≤60d)", kVencidos: "Vencidos", kIndefinidos: "Indefinidos",
          filterAll: "Todos", empty: "Sin permisos",
          stVigente: "Vigente", stPorVencer: "Por vencer", stVencido: "Vencido", stIndefinido: "Indefinido",
          lAutoridad: "Autoridad:", lEmitido: "Emitido:", lVence: "Vence:", lResponsable: "Responsable:", indef: "Indefinido",
          valPendSup: "Pendiente supervisor", valPendGer: "Pendiente gerente", valValidado: "Validado", valRechazado: "Rechazado",
          verArchivo: "Ver archivo", sinArchivo: "Sin archivo", reemplazar: "Reemplazar archivo", subir: "Subir archivo",
          supAprueba: "Supervisor aprueba", gerValida: "Gerente valida", rechazar: "Rechazar",
          rowSup: "Supervisor:", rowGer: "Gerente:", aprobado: "Aprobado", rechazado: "Rechazado", validado: "Validado",
          toastUploaded: "Archivo subido", toastApproved: "Aprobado", toastRejected: "Rechazado", toastDeleted: "Eliminado",
          promptReject: "Motivo del rechazo (obligatorio):", promptComment: "Comentario (opcional):",
          rejectNeedReason: "Motivo requerido para rechazar", confirmDelete: "¿Eliminar permiso \"{{name}}\"?",
          formTitle: "Nuevo Permiso Ambiental",
          fTipo: "Tipo de permiso", fNombre: "Nombre / Descripción", fNumero: "Número oficio",
          fAutoridad: "Autoridad", fEmision: "Fecha emisión", fVencimiento: "Fecha vencimiento",
          fResponsable: "Responsable", fResponsablePh: "Coordinación HSE", fObs: "Observaciones",
          toastSaved: "Permiso registrado",
          tLAU: "Licencia Ambiental Única (LAU)", tCOA: "Cédula de Operación Anual (COA)",
          tMIA: "Manifestación de Impacto Ambiental (MIA)", tRP: "Registro Generador de RP",
          tConaguaD: "Permiso CONAGUA — Descarga", tConaguaE: "Permiso CONAGUA — Extracción",
          tLFE: "Licencia de Funcionamiento Estatal", tOtro: "Otro",
        },
        bit: {
          title: "Bitácora de Residuos",
          subtitle: "Registro de residuos que las áreas de trabajo entregan al almacén (peligrosos, manejo especial y sólidos urbanos).",
          subtitleLink: "Cada entrega genera automáticamente un registro vinculado en el módulo Residuos (SEMARNAT).",
          reporteBtn: "Reporte Mensual", addBtn: "Registrar Entrega",
          tipoRP: "Peligroso (RP)", tipoRME: "Manejo Especial (RME)", tipoRSU: "Sólido Urbano (RSU)", entregas: "entregas",
          thFolio: "Folio", thFecha: "Fecha", thTipo: "Tipo", thDescripcion: "Descripción",
          thArea: "Área origen", thCantidad: "Cantidad", thEntregado: "Entregado por",
          thRecibido: "Recibido en almacén", thFirmas: "Firmas",
          empty: "Sin entregas registradas", pendiente: "Pendiente",
          reporteTitle: "Reporte Mensual (PDF)", reporteMes: "Mes del reporte",
          reporteHint: "Consolidado por tipo y por área, con totales y detalle de entregas del mes (para SEMARNAT/COA y auditorías).",
          generarPdf: "Generar PDF",
          lFecha: "Fecha:", lArea: "Área:", lCantidad: "Cantidad:", lDescripcion: "Descripción:",
          entregadoSlot: "Entregado por (área)", recibidoSlot: "Recibido en almacén", eliminar: "Eliminar",
          confirmDelete: "¿Eliminar el registro {{folio}}?", toastDeleted: "Registro eliminado",
          captureSign: "Captura la firma", toastSigned: "Firma guardada",
          firmar: "Firmar", nombrePh: "Nombre", traceSign: "Trazar firma", pendSign: "Pendiente de firma",
          formTitle: "Registrar Entrega al Almacén",
          fFecha: "Fecha", fTipo: "Tipo de residuo", fDescripcion: "Descripción del residuo",
          fDescripcionPh: "Ej. Estopa impregnada con solvente, cartón, rebaba metálica…",
          fArea: "Área de origen", fCantidad: "Cantidad", fUnidad: "Unidad",
          fEntregado: "Entregado por (área)", fEntregadoPh: "Nombre del trabajador",
          fRecibido: "Recibido en almacén por", fRecibidoPh: "Responsable de almacén", fObs: "Observaciones",
          validateMsg: "Completa descripción, cantidad y quién entrega", toastSaved: "Entrega registrada en bitácora",
        },
        pase: {
          listTitle: "Pases de Salida", listKicker: "Medio Ambiente · Residuos", sixSigns: "Autorización con 6 firmas",
          newBtn: "Nuevo pase", empty: "Sin pases de salida.", completo: "Completo", firmasOf: "{{n}}/6 firmas",
          newTitle: "Nuevo Pase de Salida", newDesc: "Autorización con 6 firmas para salida de residuos",
          fFecha: "Fecha", fResiduoReg: "Residuo registrado (opcional)", selPlaceholder: "Selecciona o escribe",
          manual: "Captura manual", fNombre: "Nombre del residuo *", fTipo: "Tipo",
          tipoRP: "RP (Peligroso)", tipoRME: "RME (Manejo Especial)", tipoRSU: "RSU (Urbano)",
          fCantidad: "Cantidad *", fUnidad: "Unidad", fManifiesto: "Manifiesto N°",
          fEmpresa: "Empresa transportista *", fAutSemarnat: "Autorización SEMARNAT",
          fVehiculo: "Vehículo", fVehiculoPh: "Placas, marca y modelo", fConductor: "Conductor",
          fDestino: "Destino final *", fAutDestino: "Autorización destino", fObs: "Observaciones",
          createBtn: "Crear pase", creating: "Creando…",
          reqFields: "Residuo, empresa y destino son obligatorios", toastCreated: "Pase creado, listo para firmas",
          firmarAs: "Firmar como {{role}}", fNombreCompleto: "Nombre completo *",
          fComentario: "Comentario (opcional)", reqNombre: "Nombre obligatorio", reqFirma: "Firma obligatoria",
          toastSigned: "Firma registrada", firmar: "Firmar", firma: "Firma", limpiar: "Limpiar",
          back: "Volver al listado", kicker: "Pase de Salida",
          lFecha: "Fecha", lTipo: "Tipo", lCantidad: "Cantidad", lManifiesto: "Manifiesto",
          lEmpresa: "Empresa", lVehiculo: "Vehículo", lConductor: "Conductor", lDestino: "Destino",
          autorizaciones: "Autorizaciones", noAuthRole: "Tu rol no autoriza esta firma",
          loadError: "Error al cargar pases", pdfError: "Error al generar PDF",
          confirmDelete: "¿Eliminar este pase de salida?", toastDeleted: "Eliminado",
          rRealizo: "Realizó", rRealizoWho: "Operario que ejecutó la salida",
          rEmpresa: "Empresa transportista", rEmpresaWho: "Conductor / representante",
          rSupervisor: "Supervisor", rSupervisorWho: "Supervisor de área",
          rGerente: "Gerente", rGerenteWho: "Gerente HSE / Operaciones",
          rFinanzas: "Finanzas", rFinanzasWho: "Validación financiera",
          rEmbarques: "Embarques", rEmbarquesWho: "Control de embarques",
        },
      },
      lecciones: {
        eyebrow: "HSE · Mejora continua",
        title: "Lecciones Aprendidas",
        subtitle: "Recopilación semanal automática (lunes) de actos, incidentes, A3, CAPA e inspecciones.",
        generar: "Generar recopilación",
        loading: "Cargando…",
        empty: "Aún no hay lecciones.",
        emptyHint: 'Presiona "Generar recopilación" para crear la de la semana pasada.',
        searchPlaceholder: "Buscar por folio o título…",
        yearAll: "Todos",
        noResults: "Sin resultados para los filtros.",
        registros: "registros",
        back: "Volver al listado",
        publicado: "Publicado",
        borrador: "Borrador",
        auto: "Auto",
        ia: "IA",
        weekOf: "Semana {{ini}} a {{fin}}",
        secDescripcion: "1. Descripción del acto/condición insegura o incidente",
        secCausa: "2. Causa raíz",
        secAcciones: "3. Acciones correctivas",
        secRecomendaciones: "4. Recomendaciones futuras",
        resumenLabel: "Resumen ejecutivo (IA)",
        resumenPlaceholder: 'Usa "Generar con IA" para redactar el resumen de la semana.',
        generarIA: "Generar con IA",
        generandoIA: "Generando…",
        traducir: "Traducir al inglés",
        traduciendo: "Traduciendo…",
        tTraducirOk: "Contenido traducido al inglés con IA",
        save: "Guardar",
        saving: "Guardando…",
        markPublished: "Marcar como publicado",
        pdf: "PDF",
        acusePrompt: "Confirma que leíste esta lección aprendida.",
        confirmarLectura: "Confirmar lectura",
        registrando: "Registrando…",
        confirmaste: "Confirmaste la lectura",
        confirmaronReport: "{{acked}} de {{total}} confirmaron",
        anexo: "Anexo · Registros de origen",
        thOrigen: "Origen", thArea: "Área", thFecha: "Fecha", thDescripcion: "Descripción",
        comparativoTitle: "Comparativo semanal de eventos por fuente",
        exportar: "Exportar",
        legActos: "Actos/Cond.", legIncidentes: "Incidentes", legA3: "A3", legCapa: "CAPA/JSA", legSalud: "Salud ocup.",
        cumplimientoTitle: "Cumplimiento de lectura por lección",
        cumplimientoMeta: "{{n}} personas · meta {{meta}}%",
        configurar: "Configurar",
        bajoMeta: "Bajo meta",
        pendientesTitle: "Pendientes de confirmar ({{n}})",
        todosConfirmaron: "Todo el personal confirmó la lectura.",
        excel: "Excel",
        recordarPendientes: "Recordar a pendientes",
        enviando: "Enviando…",
        recordarUno: "Recordar solo a esta persona",
        settingsTitle: "Configuración de Lecciones",
        settingsDesc: "Ajusta la meta de cumplimiento y la frecuencia de recordatorios de acuse.",
        metaLabel: "Meta de cumplimiento (%)",
        metaHint: 'Las lecciones por debajo de este % se resaltan como "Bajo meta".',
        diasLabel: "Reenviar recordatorio de acuse cada (días)",
        diasHint: "Se reenvía a quienes no han confirmado la lectura de una lección publicada.",
        cancelar: "Cancelar",
        genTitle: "Generar recopilación semanal",
        genDesc: "Se recopilan los registros de la semana (lunes a domingo). Deja la fecha vacía para la semana pasada.",
        genFechaLabel: "Fecha dentro de la semana (opcional)",
        tLoadError: "No se pudieron cargar las lecciones",
        tOpenError: "No se pudo abrir la lección",
        tGenOk: "Recopilación creada ({{n}} registros)",
        tGenExist: "Ya existía esa semana; se abrió",
        tSaved: "Guardado",
        tIAOk: "Resumen, causa raíz y recomendaciones generados con IA",
        tAcuseOk: "Acuse de lectura registrado",
        tDeleteConfirm: "¿Eliminar esta lección aprendida?",
        tDeleted: "Eliminada",
        tPdfError: "No se pudo generar el PDF",
        tExportError: "No se pudo exportar el comparativo",
        tExcelError: "No se pudo exportar la lista",
        tSettingsOk: "Configuración guardada",
        tRecordarOk: "Recordatorio enviado a {{n}} pendiente(s)",
        tRecordarNone: "Ya confirmó o no hay pendientes",
      },

    },
  },
  en: {
    translation: {
      months: {
        ene: "Jan", feb: "Feb", mar: "Mar", abr: "Apr", may: "May", jun: "Jun",
        jul: "Jul", ago: "Aug", sep: "Sep", oct: "Oct", nov: "Nov", dic: "Dec",
      },
      common: {
        save: "Save",
        cancel: "Cancel",
        create: "Create",
        delete: "Delete",
        edit: "Edit",
        close: "Close",
        accept: "Accept",
        loading: "Loading…",
        saving: "Saving…",
        creating: "Creating…",
        generating: "Generating…",
        search: "Search",
        new: "New",
        actions: "Actions",
        status: "Status",
        date: "Date",
        name: "Name",
        area: "Area",
        notes: "Notes",
        yes: "Yes",
        no: "No",
        refresh: "Refresh",
        download: "Download",
        upload: "Upload",
        confirm: "Confirm",
        all: "All",
        none: "None",
        back: "Back",
        next: "Next",
        accessDenied: "Access denied",
        notFound: "Not found",
        signOut: "Sign out",
        install: "Install app",
      },
      role: {
        gerente: "Manager",
        supervisor: "Supervisor",
        supervisor_ehs: "EHS Supervisor",
        almacen: "Warehouse",
        lider_area: "Area Leader",
        coordinador_almacen: "Warehouse Coordinator",
        coordinador_ehs: "EHS Coordinator",
        especialista_ehs: "EHS Specialist",
        logistica_ehs: "EHS Logistics",
        servicio_medico: "Medical Service",
        usuario: "User",
        super: "Super Admin",
      },
      sidebar: {
        boardEHS: "EHS Board",
        executive: "Executive",
        safety: "Safety",
        safetyDashboard: "Safety Dashboard",
        newAssessment: "New Assessment",
        history: "Analysis History",
        nomInspections: "NOM Inspections",
        autoCapa: "JSA Administration",
        a3Reports: "A3 Reports",
        capaActions: "Automatic JSA Actions",
        normsSTPS: "STPS Norms",
        health: "Occupational Health",
        environment: "Environment",
        training: "Training",
        trainingList: "List",
        trainingPlan: "Annual Plan",
        trainingAttendance: "Attendance",
        generateDC3: "Generate DC-3",
        projects: "Projects",
        config: "Settings",
        users: "Users",
        permissions: "Role permissions",
        audit: "Audit",
        lessons: "Lessons Learned",
        auditLog: "Audit Log",
        accessControl: "Access Control",
        superAdminMenu: "Super Admin (menu)",
        epp: "PPE",
        eppDashboard: "PPE Dashboard",
        eppInventory: "Inventory",
        eppMovements: "Movements",
        eppRequests: "Requests",
        eppAssignments: "Assignments",
        eppMatrix: "PPE Matrix",
        healthDashboard: "Health Dashboard",
        medicalConsultations: "Medical Consultations",
        medications: "Medications",
        medicalSurveillance: "Medical Surveillance",
        ergonomics: "Ergonomics",
        psychosocial: "Psychosocial Risks",
        environmentDashboard: "Environment Dashboard",
        waste: "Waste",
        exitPasses: "Exit Passes",
        waterConsumption: "Water Consumption",
        energyConsumption: "Energy Consumption",
        legalCompliance: "Legal Compliance",
        accessControl: "Access control",
        safetyPolicy: "Safety Policy",
        followUpProgram: "Follow-up Program",
        unsafeActsConditions: "Unsafe Acts & Conditions",
        workPermits: "Work Permits",
        procedures: "Procedures",
        plantInspections: "Plant Inspections",
        eppManagement: "PPE Management",
        disabilityControl: "Disability Control",
        wasteLog: "Waste Log",
        companies: "Companies",
        suppliers: "Suppliers",
        plantAreas: "Plant Areas",
        areaRegistry: "Area Registry",
        supDirectory: "Directory",
        supLegalDocs: "Legal Documentation",
        supAuthorizedPersonnel: "Authorized Personnel",
        supVehicles: "Vehicles",
        supDailyCheckin: "Daily Check-in",
      },
      // ===== Auditoría NOM =====
      audit: {
        title: "NOM Audit",
        subtitle: "STPS regulatory compliance · Per-requirement checklist with evidence and review",
        newAudit: "New Audit",
        newAuditDesc: "Create an annual audit pre-loaded with the 88 NOM requirements.",
        year: "Year",
        created: "Audit created",
        createError: "Could not create the audit",
        loadError: "Error loading the audit",
        empty: "No audits",
        emptyDesc: "Create your first annual NOM compliance audit.",
        open: "Open",
        backToList: "Back to audits",
        downloadPdf: "Download PDF",
        pdfError: "Could not generate PDF",
        globalCompliance: "Global compliance",
        total: "Total",
        cumple: "Compliant",
        noCumple: "Non-compliant",
        enProceso: "In progress",
        sinEvaluar: "Not evaluated",
        allFilter: "All",
        searchPlaceholder: "Search by NOM, requirement or owner…",
        noResults: "No requirements match the filter.",
        evidences: "evidence",
        section: "Section(s)",
        establishes: "What it establishes",
        toEvidence: "What must be delivered / evidenced",
        complianceStatus: "Compliance status",
        responsibleName: "Responsible name",
        responsibleArea: "Responsible area",
        deadline: "Due date",
        observations: "Evidence / Notes",
        saved: "Requirement updated",
        saveError: "Could not save",
        evidence: "Evidence",
        noEvidence: "No evidence uploaded.",
        uploadEvidence: "Upload evidence",
        uploading: "Uploading…",
        evidenceAdded: "Evidence added",
        uploadError: "Error uploading the file",
        deleteError: "Could not delete",
        reviewFlow: "Review flow",
        reviewed: "Reviewed",
        approved: "Approved",
        reviewedBy: "Reviewed by (EHS Supervisor)",
        approvedBy: "Approved by (Operations Manager)",
        markReviewed: "Review (EHS Supervisor)",
        approve: "Approve (Operations Manager)",
        reject: "Reject",
        rejectReason: "Rejection reason:",
        rejectedReason: "Rejection reason",
        actionDone: "Action applied",
        actionError: "Could not apply the action",
        rev_pendiente: "Pending",
        rev_revisado: "Reviewed (Supervisor)",
        rev_aprobado: "Approved (Manager)",
        rev_rechazado: "Rejected",
      },
      audit_log: {
        title: "Audit log",
        subtitle: "Record of security events and key actions across the application",
        exportCsv: "Export CSV",
        filters: "Filters",
        clear: "Clear",
        searchPlaceholder: "Search by user, record or detail…",
        allModules: "All modules",
        allActions: "All actions",
        allUsers: "All users",
        entries: "Entries",
        noEntries: "No entries match the filters.",
        colDate: "Date/Time",
        colUser: "User",
        colAction: "Action",
        colModule: "Module",
        colTarget: "Affected record",
        colIp: "IP",
        loadError: "Error loading the audit log",
        exportError: "Could not export",
        forbidden: "Only the Super Admin can view the audit log",
      },
      access: {
        title: "Access Control",
        subtitle: "Define which menu modules each user can see",
        hint: "Check a module to grant access to its dashboard. Expand (›) to enable specific screens. Each checkbox is independent.",
        screens: "screens",
        mainOnly: "dashboard",
        childHint: "Each screen is independent: checking the parent module only grants its main dashboard, not all screens.",
        loadError: "Error loading data",
        searchUser: "Search user…",
        noUsers: "No users",
        pickUser: "Select a user to configure their access",
        customAccess: "Custom access",
        unconfigured: "Not configured (no access)",
        fullAccess: "Full access",
        selectAll: "All",
        selectNone: "None",
        superNote: "The Super Admin has full access to all modules and cannot be restricted here.",
        saveAccess: "Save access",
        saved: "Access updated",
        saveError: "Could not save",
        clearAccess: "Remove all access",
        clearedDone: "All access removed for the user",
        modulesEnabled: "modules enabled",
        emptyWarning: "You have not selected any module. If you save like this, this user will NOT see any menu option. Do you want to continue?",
      },
      login: {
        title: "Sign in",
        email: "Email",
        password: "Password",
        signIn: "Sign in",
        emailPlaceholder: "user@lgmg.com",
        subtitle: "Integrated System · Health, Safety and Environment",
        footer: "Safety, Health and Environmental Management",
        norms: "STPS · OSHA · ISO 45001 · ISO 14001",
        invalidCredentials: "Invalid credentials",
        remember: "Remember me",
        forgot: "Forgot your password?",
        forgotTitle: "Recover password",
        forgotDesc: "Enter your email and we'll send you a link to create a new password.",
        forgotSend: "Send link",
        forgotSent: "If the email is registered, we'll send you a link to reset your password.",
      },
      bbs: {
        title: "BBS · Behavior-Based Safety",
        subtitle: "Observation of safe and unsafe behaviors · % safe by area and category.",
        newObs: "New observation", pdf: "PDF", search: "Search by observer, area…",
        observations: "observations", kpiObs: "OBSERVATIONS", kpiPct: "% SAFE",
        kpiSafe: "SAFE BEHAVIORS", kpiUnsafe: "UNSAFE BEHAVIORS",
        byCategory: "Behaviors by category", pctByArea: "% Safe by area",
        trend: "% Safe trend (monthly)", noData: "No data yet",
        objective: "Target", inObjective: "On target", atRisk: "At risk", offObjective: "Below target",
        safe: "Safe", unsafe: "Unsafe", save: "Save", cancel: "Cancel",
        colDate: "Date", colObserver: "Observer", colArea: "Area", colSafe: "Safe",
        colUnsafe: "Unsafe", colPct: "% Safe", colDesc: "Description", emptyList: "No observations yet. Add the first one.",
        formTitle: "New BBS observation", observer: "Observer", area: "Area", date: "Date",
        shift: "Shift", peopleObserved: "People observed", behaviors: "Observed behaviors",
        descObserved: "Description of what was observed", immediateAction: "Immediate action", commitment: "Commitment / follow-up",
        scorecard: "BBS indicators scorecard", totalWorkers: "Total workers",
        indicators: "Indicators (scorecard)", qualityObs: "Quality observation", recurrent: "Recurrent behavior",
        actionClosed: "Action closed on time", closeDays: "Days to close",
        colIndicator: "Indicator", colFormula: "Formula", colTarget: "Target", colResult: "Result", colStatus: "Status",
        meets: "Meets", notMeet: "Below", days: "days",
        scHint: "Coverage and participation require the “Total workers”. Quality, closure, time and recurrence are computed from the fields captured in each observation.",
        sc1: "Observation coverage", sc2: "Observation quality", sc3: "% of safe critical behaviors",
        sc4: "Action closure rate", sc5: "Average closure time", sc6: "Worker participation",
        sc7: "Recurrence of at-risk behaviors",
        errObs: "Observer and area are required", saved: "BBS observation saved",
        deleted: "Deleted", confirmDel: "Delete this observation?", cfgSaved: "Settings updated",
        na: "N/A", noDataShort: "No data", topObservers: "Top observers", colCategory: "Category",
        objectiveLine: "{{label}} — {{pct}}% safe (target {{meta}}%)",
        objectiveBtn: "Target: {{n}}%", totalWorkersLabel: "Total workers: {{n}}",
        areaPh: "e.g. Welding", shiftPh: "Morning / Evening",
        pdfHeaderTitle: "BBS Behavior-Based Safety",
        pdfHeaderSub: "Observations of safe and unsafe behaviors",
        pdfSemLine: "{{label}}: {{pct}}% of {{meta}}% target",
        pdfFooter: "HSE · BBS · Confidential",
        pdfPage: "Page {{p}} of {{total}}",
        pdfCardObs: "OBSERVATIONS", pdfCardSafe: "% SAFE", pdfCardTarget: "TARGET", pdfCardUnsafe: "UNSAFE",
        pdfColObs: "Observations",
        f1: "Workers observed / Total workers × 100",
        f2: "Quality observations / Total observations × 100",
        f3: "Safe behaviors / Total observed × 100",
        f4: "Actions closed on time / Actions generated × 100",
        f5: "Sum of days / Total closed actions",
        f6: "Participating workers / Total workers × 100",
        f7: "Recurrent / Total at-risk behaviors × 100",
        cat: {
          "Uso de EPP": "PPE use",
          "Posición / Ergonomía": "Posture / Ergonomics",
          "Herramientas y equipo": "Tools and equipment",
          "Procedimientos / Permisos": "Procedures / Permits",
          "Orden y limpieza": "Housekeeping",
          "Reacción de las personas": "People's reaction",
          "Otros": "Others",
        },
      },
      executive: {
        title: "HSE Executive Dashboard",
        subtitle: "{{company}} · Safety · Health · Environment · Integrated KPIs",
        updated: "Updated",
        period: "Period",
        thisMonth: "This month",
        quarter: "Quarter",
        last12m: "Last 12 months",
        total: "Total",
        avgCompliance: "Average compliance",
        inspections: "Inspections performed",
        criticalFindings: "Critical findings",
        overdueCAPA: "Overdue CAPAs",
        monthlyTrend: "Monthly trend (6 months)",
        monthlyTrendSubtitle: "% compliance + CAPA flow",
        capaStatus: "CAPA Status",
        capaByOrigin: "CAPAs by origin",
        capaBySeverity: "CAPAs by severity",
        autoOrigin: "Automatic source",
        severity: "Severity",
        compliancePct: "% Compliance",
        capaOpen: "Open CAPAs",
        capaClosed: "Closed CAPAs",
        open: "Open",
        inProgress: "In progress",
        closed: "Closed",
        overdue: "Overdue",
        extreme: "Extreme",
        high: "High",
        medium: "Medium",
        low: "Low",
        sourceNom: "NOM Inspections",
        sourceVigilancia: "Medical Surveillance",
        sourceErgonomia: "Ergonomics",
        sourcePsicosocial: "NOM-035",
        sourceCumplimiento: "NOM Compliance",
        pMonth: "Month",
        pTotal: "Total",
        year: "Year",
        yearTooltipDisabled: "Year applies only to quarters (Q1–Q4)",
        yearTooltip: "Select the quarter year",
        viewDetail: "View detail",
        viewDetailArrow: "View detail →",
        loading: "Loading dashboard…",
        loadError: "Could not load the dashboard.",
        pdfDownloaded: "PDF downloaded",
        pdfError: "Error exporting PDF: ",
        noData: "No data.",
        inspByMonth: "Inspections per month",
        last6m: "Last 6 months",
        inspectionsName: "Inspections",
        capaEffectiveness: "CAPA effectiveness",
        closeRateSub: "Period close rate",
        closedLower: "closed",
        capasClosedLabel: "Closed CAPAs",
        avgCloseDays: "avg. close days",
        findingsBySeverity: "Findings by severity",
        criticalVsNon: "Critical vs non-critical",
        noFindings: "No findings recorded.",
        critical: "Critical",
        nonCritical: "Non-critical",
        capaName: "CAPAs",
        top5Areas: "Top 5 areas with most findings",
        findingsName: "Findings",
        top5Noms: "Top 5 NOMs with most findings",
        noFindingsShort: "No findings.",
        capaByArea: "CAPAs by area",
        capaByAreaSub: "Corrective actions generated per area",
        noCapaPeriod: "No CAPAs in the period.",
        capaByResp: "CAPAs by owner",
        capaByRespSub: "Action load per assigned person",
        actsVsConditions: "Unsafe Acts vs Conditions",
        totalLabel: "Total",
        openLabel: "Open",
        acTrendSub: "Monthly trend (last 6 months)",
        unsafeActs: "Unsafe acts",
        unsafeConditions: "Unsafe conditions",
        noRecordsPeriod: "No records in the period.",
        acByArea: "Acts & conditions by area",
        top8Areas: "Top 8 areas with most observations",
        acts: "Acts",
        conditions: "Conditions",
        bodyPart: "Affected body part",
        incidentsPeriod: "Incidents in the period",
        bodyPartSub: "Injuries by body zone (top 10)",
        incidentsName: "Incidents",
        noBodyPart: "No incidents with recorded body part in the period.",
        incBySeverity: "Incidents by severity",
        severityScale: "Minor · Moderate · Severe · Fatal",
        noIncidentsPeriod: "No incidents in the period.",
        incByType: "Incidents by type",
        typeScale: "Accident · Near miss · First aid",
        healthPanel: "Occupational Health",
        exams: "Exams",
        notFit: "Not fit",
        fitRestrictions: "Fit w/restrictions",
        ergoVeryHigh: "Ergonomics Very High",
        nom035Clinical: "NOM-035 clinical care",
        medicalFitDist: "Medical fitness distribution",
        fit: "Fit",
        withRestrictions: "With restrictions",
        notFitSingle: "Not fit",
        eppPanel: "PPE",
        eppItems: "PPE items",
        lowStock: "Low stock",
        pendingRequests: "Pending requests",
        expiring7d: "Expiring (7d)",
        expired: "Expired",
        envPanel: "Environment",
        rpGenerated12m: "Hazardous waste 12m",
        co2Year: "CO₂e footprint year",
        permitsExpiring: "Permits expiring",
        permitsExpired: "Permits expired",
        quickAccess: "Quick Access",
        qNewEval: "New Assessment",
        qA3: "A3 Reports",
        qNorms: "STPS Standards",
        qInventory: "PPE Inventory",
        qTraining: "Training",
        qWaste: "Waste",
        qActs: "Unsafe Acts & Conditions",
        disabilityControl: "Disability Control",
        incShort: "Disabilities",
        lostDays: "Lost days",
        activeCases: "Active cases",
        mainCause: "Main cause",
        lostDaysAccum: "Accumulated lost days",
        activeCasesFollow: "Active cases / follow-up",
        maternityPct: "% maternity share",
        avgDaysCase: "Avg. days per case",
        daysUnit: "days",
        rpLoading: "Loading waste report…",
        rpTitle: "Hazardous Waste Management",
        rpCarrier: "Carrier",
        rpFinalDisposal: "Final Disposal",
        rpPeriod: "Period",
        rpTotalWeight: "Total Weight Generated",
        rpEquivTo: "equivalent to",
        rpContainers: "Total Containers",
        rpContainersSub: "Totes, Drums and Pallets",
        rpTotalSpend: "Total Spend",
        rpNoVat: "before tax",
        rpManifests: "Manifests Issued",
        rpNoWaste: "No hazardous waste recorded in",
        rpWeightByMonth: "Weight Generated per Month (kg)",
        rpDistByType: "Distribution by Waste Type",
        rpGenByArea: "Generation by Area (kg)",
        rpMonthlySummary: "Monthly Manifest Summary",
        rpThMonth: "Month",
        rpThManifests: "Manifests",
        rpThWeight: "Weight (kg)",
        rpThCont: "Cont.",
        rpThSpend: "Spend",
        rpManifestsWord: "manifests",
        execAiTitle: "Executive Summary (AI)",
        focosLabel: "Focus points",
        execGenerating: "Generating…",
        execTablesTitle: "Executive tables",
        tblAreasTitle: "Highest-risk areas",
        tblAreasEmpty: "No findings in the period",
        colArea: "Area",
        colFindings: "Findings",
        tblNomsTitle: "Findings by NOM",
        tblNomsEmpty: "No findings by NOM",
        colNorm: "Standard",
        tblCapasTitle: "CAPAs by owner",
        tblCapasEmpty: "No CAPAs in the period",
        colResponsible: "Owner",
        colCapas: "CAPAs",
        tblExamsTitle: "Medical exams expired / expiring",
        tblExamsEmpty: "Medical surveillance up to date",
        colWorker: "Worker",
        colStatus: "Status",
        statusExpired: "Expired",
      },
      dir: {
        title: "DIR · HSE Expense Control",
        subtitle: "Annual budget vs. actual spend across Safety, Health, Environmental and Training.",
        loading: "Loading expense control…",
        pdf: "PDF",
        excel: "Excel",
        budgetBtn: "Budget",
        addExpense: "Record expense",
        kpiBudget: "Annual budget",
        kpiSpent: "Spent",
        kpiAvailable: "Available",
        kpiPct: "% used",
        fModule: "Module",
        fArea: "Area",
        fType: "Expense type",
        fFrom: "From",
        fTo: "To",
        fWeek: "Week",
        all: "All",
        allF: "All",
        clearFilters: "Clear filters",
        weekPriority: "The selected week takes priority over the date range.",
        monthlySpend: "Monthly spend by module",
        distribution: "Distribution",
        noExpensesReg: "No expenses recorded",
        overBudget: "Over budget",
        ofWord: "of",
        available: "Available",
        exceeded: "Exceeded",
        noExpensesModule: "No expenses in this module",
        detailTitle: "Expense detail",
        thDate: "Date",
        thModule: "Module",
        thSubmodule: "Submodule",
        thArea: "Area",
        thConcept: "Concept",
        thAmount: "Amount",
        thProvider: "Provider",
        noExpensesFilters: "No expenses with the current filters",
        dlgTitle: "Record expense",
        editTitle: "Edit expense",
        edit: "Edit",
        updated: "Expense updated",
        saveChanges: "Save changes",
        lblModule: "Module *",
        lblType: "Expense type",
        lblSubmodule: "Submodule *",
        lblConcept: "Concept *",
        phConcept: "Expense description",
        lblAmount: "Amount (MXN) *",
        lblDate: "Date *",
        lblArea: "Area",
        phArea: "Production, Warehouse…",
        lblProvider: "Provider",
        lblFolio: "Folio / Invoice (traceability)",
        phFolio: "A-12345",
        lblNote: "Note (optional)",
        phNote: "Additional detail for audit",
        cancel: "Cancel",
        record: "Record",
        saving: "Saving…",
        presuTitle: "Annual budget {{year}} (MXN)",
        loadingShort: "Loading…",
        totalAnnual: "Annual total",
        moveBudget: "Move budget",
        from: "From",
        to: "To",
        amountToMove: "Amount to move",
        move: "Move",
        moving: "Moving…",
        moveHint: "Move budget from one module to another without changing the annual total.",
        reassignHistory: "Reassignment history",
        saveBudget: "Save budget",
        errLoad: "Could not load expense control",
        errExport: "Could not export",
        confirmDelete: "Delete the expense \"{{concept}}\" ({{amount}})?",
        deleted: "Expense deleted",
        errDelete: "Could not delete",
        conceptAmountReq: "Concept and amount are required",
        recorded: "Expense recorded",
        errRecord: "Could not record",
        budgetSaved: "Budget {{year}} saved",
        errSave: "Could not save",
        moveGt0: "Enter an amount greater than 0 to move",
        fromToDiff: "Source and destination must be different",
        moved: "Moved {{amount}} from {{from}} to {{to}}",
        errReassign: "Could not reassign",
        alertOver: "{{module}}: {{pct}}% used (over budget by {{amount}})",
        alertNear: "{{module}}: {{pct}}% of budget used",
        modules: {
          seguridad: "Safety",
          salud: "Occupational Health",
          ambiental: "Environmental",
          capacitacion: "Training",
        },
        tipos: {
          "Material/Consumible": "Material/Consumable",
          "Servicio": "Service",
          "Equipo (CAPEX)": "Equipment (CAPEX)",
          "Análisis/Estudio": "Analysis/Study",
          "Disposición/Manejo": "Disposal/Handling",
          "Capacitación": "Training",
          "Otro": "Other",
        },
        submodulos: {
          "EPP (Equipo de Protección Personal)": "PPE (Personal Protective Equipment)",
          "Inspecciones y Auditorías NOM": "NOM Inspections & Audits",
          "Señalización y Permisos de Trabajo": "Signage & Work Permits",
          "Simulacros y Emergencias": "Drills & Emergencies",
          "Equipo contra incendio": "Fire-fighting equipment",
          "Exámenes médicos y Vigilancia": "Medical exams & Surveillance",
          "Medicamentos y Botiquín": "Medications & First-aid kit",
          "Consultas y Servicio Médico": "Consultations & Medical service",
          "Estudios especiales (audiometría, espirometría)": "Special studies (audiometry, spirometry)",
          "Ergonomía y Psicosocial (NOM-035)": "Ergonomics & Psychosocial (NOM-035)",
          "Manejo de residuos (RP/RME/RSU)": "Waste management (RP/RME/RSU)",
          "Monitoreo y análisis (agua, aire, ruido)": "Monitoring & analysis (water, air, noise)",
          "Permisos y licencias (SEMARNAT)": "Permits & licenses (SEMARNAT)",
          "Disposición final y transporte": "Final disposal & transport",
          "Certificaciones ambientales": "Environmental certifications",
          "Cursos internos": "Internal courses",
          "Cursos externos e instructores": "External courses & instructors",
          "Certificaciones y DC-3": "Certifications & DC-3",
          "Material didáctico": "Training material",
          "Plataforma y licencias": "Platform & licenses",
        },
      },
      areasAdmin: {
        title: "Plant Areas",
        subtitle: "Manage areas. They feed Ergonomics, Unsafe Acts & Conditions, JSA, Risk Analysis and Inspections.",
        newArea: "New Area",
        editArea: "Edit Area",
        thName: "Name",
        thDescription: "Description",
        thActions: "Actions",
        loading: "Loading...",
        empty: "No areas registered yet.",
        edit: "Edit",
        delete: "Delete",
        optional: "optional",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        created: "Area created",
        updated: "Area updated",
        deleted: "Area deleted",
        confirmDelete: "Delete the area \"{{name}}\"?",
      },

      usersAdmin: {
        title: "User Management",
        subtitle: "User · Supervisor · Warehouse · Manager",
        viewAllCompanies: "View all companies",
        newUser: "New User",
        mainNoCompany: "Main / No company",
        viewAll: "View all",
        thName: "Name",
        thEmail: "Email",
        thRole: "Role",
        thStatus: "Status",
        thCompany: "Company",
        thArea: "Area",
        thEmployeeId: "Employee ID",
        thActions: "Actions",
        loading: "Loading...",
        suspended: "Suspended",
        active: "Active",
        menu: "Menu",
        permissions: "Permissions",
        activateAccount: "Activate account",
        suspendAccount: "Suspend account",
        deleteAccount: "Delete account",
        noCompany: "No company",
        fullName: "Full name",
        password: "Password",
        pwdHint: "Min. 12 characters, with uppercase, lowercase, number and symbol.",
        area: "Area",
        selectPlaceholder: "Select...",
        optional: "optional",
        cancel: "Cancel",
        create: "Create",
        creating: "Creating...",
        userCreated: "User created",
        userAssigned: "User assigned to company",
        userDeleted: "User deleted",
        roleUpdated: "Role updated",
        accountSuspended: "Account suspended",
        accountActivated: "Account activated",
        confirmDelete: "Delete {{name}}?",
        confirmSuspend: "Suspend {{name}}'s account? They won't be able to sign in until reactivated.",
        pwdStrength: "Password requirements",
        pwdReqLength: "At least 12 characters",
        pwdReqUpper: "An uppercase letter (A-Z)",
        pwdReqLower: "A lowercase letter (a-z)",
        pwdReqDigit: "A number (0-9)",
        pwdReqSymbol: "A symbol (!@#$…)",
        menuVisible: "Visible menu",
        menuCustomHint: "This user has custom access. Check/uncheck to adjust.",
        menuNoneHint: "No access configured. Check the boxes to assign visible modules.",
        menuUpdated: "Menu updated for",
        removeAccess: "Remove access",
        confirmClearMenu: "Remove all menu access from this user?",
        menuAccessRemoved: "Menu access removed",
        save: "Save",
        saving: "Saving…",
        saveItems: "Save ({{count}} items)",
        capsTitle: "Action permissions",
        capsAlwaysAll: "Manager and Super Admin always have all permissions.",
        capsHint: "Enable or disable what this user can do across the app.",
        savePerms: "Save permissions",
        permsUpdated: "Permissions updated for",
        capDelete: "Delete",
        capDeleteDesc: "Can delete records (projects, waste, users, etc.).",
        capEdit: "Edit",
        capEditDesc: "Can modify existing records.",
        capPdf: "Download PDF",
        capPdfDesc: "Can export/download PDF reports.",
        capIa: "Use AI",
        capIaDesc: "Can use AI generation buttons (procedures, control measures).",
      },

      ehs: {
        section: "Industrial Safety",
        title: "EHS Performance",
        subtitle: "OSHA/STPS KPIs · Frequency · Severity · Lost days",
        registerIncident: "Register incident",
        configure: "Configure",
        from: "From",
        to: "To",
        area: "Area",
        supervisor: "Supervisor",
        allAreas: "All areas",
        all: "All",
        hhPeriod: "Man-hours period",
        avgWorkers: "Avg. workers",
        ifFreq: "Frequency Index",
        isSev: "Severity Index",
        lostDays: "Lost days",
        totalIncidents: "Total incidents",
        registrables: "Recordable accidents",
        thresholdSub: "Threshold 🟢 ≤{{g}} · 🟡 ≤{{y}}",
        accumPeriod: "accumulated period",
        incidentsSub: "{{acc}} acc. · {{near}} near · {{fa}} first aid",
        rateSub: "Rate /100 workers: {{rate}}",
        monthlyTrend: "Monthly trend (FI & SI)",
        incidentsByArea: "Incidents by area",
        bySeverity: "By severity",
        noIncidentsPeriod: "No incidents in the period.",
        accidents: "Accidents",
        nearMisses: "Near misses",
        incidents: "Incidents",
        loading: "Loading EHS dashboard…",
        noData: "No data.",
        dlgTitle: "Register incident",
        dlgDesc: "Record accidents, near misses and first aid.",
        type: "Type",
        date: "Date",
        severity: "Severity",
        typeAccident: "Accident",
        typeNear: "Near miss",
        typeFirstAid: "First aid",
        sevLeve: "Minor",
        sevModerado: "Moderate",
        sevGrave: "Severe",
        sevFatal: "Fatal",
        supervisorName: "Supervisor name",
        affectedWorker: "Affected worker",
        workerPlaceholder: "Name or ID",
        lostDaysField: "Lost days",
        recordable: "Recordable (OSHA/STPS)",
        bodyPart: "Affected body part",
        bodyPartPlaceholder: "E.g. left hand, eye, back",
        description: "Description",
        descPlaceholder: "What happened?",
        immediateAction: "Immediate corrective action",
        actionPlaceholder: "What was done?",
        cancel: "Cancel",
        register: "Register",
        saving: "Saving…",
        yes: "Yes",
        no: "No",
        selectArea: "Select the area",
        describeAccident: "Describe the accident",
        incidentSaved: "Incident recorded",
        incidentUpdated: "Incident updated",
        incidentDeleted: "Incident deleted",
        editTitle: "Edit incident",
        saveChanges: "Save changes",
        recordsTitle: "Recorded incidents",
        records: "records",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        confirmDelete: "Delete this incident? This action cannot be undone.",
        errorSaving: "Error saving",
        errorLoadDash: "Error loading EHS dashboard",
        cfgTitle: "Configure EHS",
        cfgDesc: "Monthly workforce and traffic-light thresholds",
        thresholds: "Traffic-light thresholds",
        ifGreen: "FI Green ≤",
        ifYellow: "FI Yellow ≤",
        isGreen: "SI Green ≤",
        isYellow: "SI Yellow ≤",
        thresholdHint: "If FI exceeds yellow → 🔴 red. Same criterion for SI.",
        monthlyWorkforce: "Monthly workforce",
        defaultLine: "Default: {{w}} workers × {{h}} h/month",
        colMonth: "Month",
        colWorkers: "Workers",
        colHours: "Hours/worker",
        colHH: "Total MH",
        configSaved: "Configuration saved",
        errorLoadCfg: "Error loading configuration",
        save: "Save",
        selectPlaceholder: "Select",
        good: "Good",
        attention: "Attention",
        criticalStatus: "Critical",
      },
      quick: {
        title: "Quick actions",
        subtitle: "Create new record",
        close: "Close",
        newEpp: "New PPE request",
        newConsulta: "New medical consultation",
        newRiesgo: "New risk assessment",
        newPermiso: "New work permit",
        newActo: "New unsafe act or condition",
      },
      notif: {
        title: "Notifications",
        desc: "Compliance alerts, expirations and HSE system events",
        markAll: "Mark all read",
        empty: "No notifications",
        markedRead: "Notifications marked as read",
        markError: "Could not mark as read",
        unread: "Unread",
        justNow: "just now",
        minsAgo: "{{n}} min ago",
        hoursAgo: "{{n}} h ago",
        daysAgo: "{{n}} d ago",
      },
      acuse: {
        ackedOn: "You acknowledged receipt on {{date}}",
        confirmRead: "Confirm you have read and understood this document.",
        registering: "Registering…",
        ackButton: "Acknowledge receipt",
        ackSuccess: "Acknowledgment of receipt recorded. Thank you!",
        ackError: "Could not record the acknowledgment",
        tracking: "Acknowledgment tracking",
        acked: "Acknowledged ({{n}})",
        noneYet: "No one yet",
        pending: "Pending ({{n}})",
        allUpToDate: "Everyone up to date! 🎉",
      },
      gami: {
        ranking: "HSE Ranking",
        levels: {
          "Aprendiz": "Apprentice",
          "Bronce": "Bronze",
          "Plata": "Silver",
          "Oro": "Gold",
          "Platino": "Platinum",
          "Diamante": "Diamond",
          "Maestro HSE": "HSE Master",
          "Leyenda HSE": "HSE Legend",
        },
      },
      offline: {
        online: "Online",
        pendingUpload: "Pending upload",
        noConnection: "No connection",
        inQueue: "{{count}} record(s) queued",
        offlineMode: "Offline mode active",
        syncing: "Syncing…",
        syncNow: "Sync now",
      },
      plant: {
        plant: "Plant",
        active: "Active plant",
        select: "Select plant",
      },
      saludDash: {
        loading: "Loading health dashboard...",
        title: "Occupational Health Dashboard",
        subtitle: "NOM-030 (Surveillance) · NOM-036 (Ergonomics) · NOM-035 (Psychosocial) · DC-3",
        examsExpired: "Expired exams",
        notFit: "Not fit",
        ergoHigh: "Ergo High/Very High",
        nom035High: "NOM-035 High",
        vigTotal: "Surveillance (total)",
        fitRestr: "Fit w/ restrictions",
        ergoEvals: "Ergo evaluations",
        trainingValid: "Valid trainings",
        ergoByLevel: "Ergonomics by Risk Level",
        noEvals: "No evaluations.",
        nom035ByLevel: "NOM-035 by Psychosocial Risk Level",
        noQuestionnaires: "No questionnaires.",
        lvlNulo: "None", lvlBajo: "Low", lvlMedio: "Medium", lvlAlto: "High", lvlMuyAlto: "Very High",
      },
      eppDash: {
        loading: "Loading PPE dashboard...",
        noData: "No data.",
        title: "PPE Dashboard",
        subtitle: "Personal Protective Equipment Management · LGMG",
        activeItems: "Active Items",
        lowStock: "Low Stock",
        pendingReq: "Pending Requests",
        expiring7d: "Expiring (7d)",
        expired: "Expired",
        movementsToday: "Movements Today",
        inventoryValue: "Inventory Value",
        movByType: "Movements by Type (30d)",
        noMov30d: "No movements in the last 30 days.",
        consByArea: "Consumption by Area (30d)",
        noCons: "No consumption recorded.",
        lowStockItems: "Low Stock Items",
        min: "Min",
        typeEntry: "Entries", typeExit: "Exits", typeReplacement: "Replacement", typeAdjustment: "Adjustments",
      },
      ambDash: {
        loading: "Loading environment dashboard...",
        title: "Environment Dashboard",
        subtitle: "Waste · Consumption · Carbon Footprint · SEMARNAT Compliance",
        rpGenerated: "Hazardous waste generated ({{year}})",
        rpYear: "HW year",
        co2Year: "CO₂ footprint current year",
        servicesCost: "Services cost year",
        permitsExpVenc: "Permits expired / expiring",
        rpTrend: "Hazardous Waste Trend ({{year}})",
        noDataResiduos: "No data. Record at /residuos.",
        consByType: "Year Consumption by Type",
        noDataConsumos: "No data. Record at /consumos.",
        residuosByType: "Waste by Type ({{year}})",
        noResiduos: "No waste recorded.",
        colType: "Type", colQty: "Quantity", colRecords: "Records", colDeliveries: "Deliveries",
        permitsExpiring: "Permits About to Expire",
        noCriticalPermits: "No critical permits.",
        expires: "Expires",
        bitacoraByType: "Warehouse Log by Type (12m)",
        noDeliveries: "No deliveries recorded. Record at /ambiente/bitacora-residuos.",
        noDeliveriesShort: "No deliveries recorded.",
        bitacoraByArea: "Warehouse Log by Area (12m)",
        tipoRP: "Hazardous", tipoRME: "Special Handling", tipoRSU: "Urban Solid",
        consAgua: "Water", consElectricidad: "Electricity", consGasLp: "LP Gas", consGasNatural: "Natural Gas", consDiesel: "Diesel", consGasolina: "Gasoline",
      },
      superAdmin: {
        title: "Super Admin",
        subtitle: "Menu visibility · Locks · Deletion",
        tabMenu: "Menu visibility",
        tabUsers: "Users & locks",
        gerenteAlways: "The Manager role always has full system access. Restriction is not possible.",
      },
      training: {
        section: "Training",
        planAnnualTitle: "Annual Plan",
        planAnnualSubtitle: "Courses planned by NOM and area",
        attendanceTitle: "Attendance",
        attendanceSubtitle: "Mass check-in per session",
        newCourse: "New course",
        newSession: "New session",
        totalCourses: "Total courses",
        completed: "Completed",
        ongoing: "Ongoing",
        executedHours: "Executed hours",
        peopleTrained: "People trained",
        progress: "% Progress",
        coursesIn: "{{count}} course(s)",
        noCoursesPlanned: "No planned courses",
        sessions: "{{count}} session(s)",
        hExec: "{{h}}h done",
        people: "{{n}} people",
        status: {
          planeada: "Planned",
          en_curso: "Ongoing",
          completada: "Completed",
          cancelada: "Cancelled",
        },
        title: "Title",
        instructor: "Instructor",
        nomOptional: "NOM (optional)",
        startTime: "Start time",
        endTime: "End time",
        durationH: "Duration (h)",
        location: "Location",
        notes: "Notes",
        linkToPlan: "Link to Annual Plan (optional)",
        noLink: "— No link —",
        linkHint: "When linked, the plan switches to \"ongoing\" and the session counts toward its progress.",
        createAndCapture: "Create and capture",
        checkin: "Check-in",
        importList: "Import list (paste from Excel)",
        importPlaceholder: "Name, ID, CURP, Area, Position (one attendee per line)\nE.g.: Juan Pérez, EMP-001, PEJU890101HDFRRN02, Welding, Welder",
        importLines: "Import {{n}} line(s)",
        present: "present",
        markAll: "Mark all",
        clearAll: "Clear",
        addRow: "Row",
        saveAttendance: "Save attendance",
        empty: "No attendees. Import a list or add rows manually.",
        noSessions: "No sessions recorded for {{year}}",
        dc3Bulk: "Bulk DC-3",
        dc3BulkTitle: "Generate bulk DC-3",
        dc3BulkInfo: "{{n}} signed attendee(s) with CURP — a PDF will be generated for each.",
        dc3BulkWarn: "{{n}} signed without CURP will be skipped. Add CURP during check-in to include them.",
        dc3CompanyData: "Company data",
        legalName: "Legal name",
        rfc: "RFC",
        activity: "Economic activity",
        address: "Address",
        trainerCurp: "Trainer CURP",
        stpsRegistration: "STPS Registration",
        course: "Course",
        thematicArea: "Thematic area",
        modality: "Modality",
        employerRep: "Employer representative",
        position: "Position",
        downloadZip: "Download {{n}} DC-3 (ZIP)",
        generatingZip: "Building ZIP…",
      },
      // ===== Safety =====
      seg: {
        loading: "Loading…", cancel: "Cancel", create: "Create", creating: "Creating…",
        view: "View →", newInspection: "New Inspection",
        ip: {
          title: "Plant Inspections",
          subtitle: "Safety walkthrough across the 21 plant categories · 5×5 Matrix · Automatic CAPA",
          kTotal: "Total walkthroughs", kCompliance: "Average compliance",
          kNoCumple: "Non-conformities", kCritical: "Critical findings (High/Extreme)",
          thFecha: "Date", thFolio: "Folio", thArea: "Area / Zone", thInspector: "Inspector",
          thCumplimiento: "Compliance", thNoCumple: "Fail", thCriticos: "Critical", thCapas: "CAPAs",
          empty: "No plant inspections yet. Create the first one to get started.",
        },
        nomi: {
          title: "STPS NOM Inspections",
          subtitle: "Official checklists with 5×5 matrix, photographic evidence and automatic CAPA",
          kTotal: "Total inspections", kCompliance: "Average compliance",
          kNoCumple: "Non-conformities", kCritical: "Critical findings (High/Extreme)",
          thFecha: "Date", thNom: "NOM", thArea: "Area", thInspector: "Inspector",
          thCumplimiento: "Compliance", thNoCumple: "Fail", thCriticos: "Critical", thCapas: "CAPAs",
          empty: "No inspections yet. Create the first one to get started.",
        },
        proc: {
          title: "Standard Safety Procedures",
          subtitle: "One procedure per STPS Norm, with the most relevant points and Supervisor & Manager signatures.",
          newBtn: "New Procedure",
          searchPh: "Search by NOM, title or author...",
          fAll: "All",
          noResults: "No procedures match your search.",
          emptyList: "No procedures.",
          stSinRedactar: "Not drafted", stAutorizado: "Authorized", stPendiente: "Pending signature",
          loadErr: "Could not load procedures",
          confirmDelCustom: "Delete procedure \"{{name}}\"? This action cannot be undone.",
          confirmDelNom: "Delete the content and signatures of {{name}}? The card will remain but blank (\"Not drafted\").",
          delCustomOk: "Procedure deleted", delNomOk: "Content deleted", delErr: "Could not delete",
          delTitle: "Delete", editedBy: "Edited by {{name}}", custom: "Custom",
          newTitle: "New Procedure", fTitulo: "Title", fTituloPh: "E.g. Internal lockout/tagout (LOTO)",
          fCodigo: "Code / Reference (optional)", fCodigoPh: "E.g. PRO-INT-01",
          fCodigoHint: "If left empty, an automatic code is assigned.",
          needTitle: "Enter a title", createdOk: "Procedure created", createErr: "Could not create",
        },
        pd: {
          back: "Back to Procedures", loadErr: "Could not load the procedure",
          loadingProc: "Loading procedure…", notFound: "Not found",
          s1: "1. Objective", s2: "2. Scope", s3: "3. Responsibilities", s4: "4. Development",
          s5: "5. Required PPE", s6: "6. Regulatory references",
          autorizado: "AUTHORIZED", pendiente: "PENDING AUTHORIZATION",
          generando: "Generating…", regenerarIA: "Regenerate with AI", generarBorradorIA: "Generate draft (AI)",
          editar: "Edit", editarEncabezado: "Edit header", eliminar: "Delete",
          confirmRegen: "The procedure is authorized. Regenerating will reset the signatures. Continue?",
          borradorGen: "Draft generated with AI", borradorGenReset: "Draft generated. Signatures were reset.",
          genErr: "Could not generate the draft",
          emptyMsg: "This procedure has no content yet.", generarConIA: "Generate draft with AI",
          tituloProc: "Procedure title", codigoRef: "Code / Reference (NOM)", codigoPh: "E.g. NOM-004-STPS-1999",
          unElemPorLinea: "One item per line", escribeUnElem: "Write one item per line.",
          guardar: "Save", guardando: "Saving…", cancelar: "Cancel",
          savedOk: "Procedure saved", savedReset: "Content edited. Signatures were reset; it must be re-authorized.",
          saveErr: "Could not save",
          noAutorizadoNota: "This procedure is not authorized until it has the Supervisor and Manager signatures.",
          sinContenido: "No content",
          confirmDelCustom: "Delete this custom procedure? This action cannot be undone.",
          confirmDelNom: "Delete the content and signatures of {{name}}? The procedure will be left blank (\"Not drafted\").",
          delOk: "Procedure deleted", delContentOk: "Content deleted", delErr: "Could not delete",
          pdfErr: "Could not download the PDF",
          evidencias: "Evidence / Attachments", foto: "Photo", documento: "Document", subiendo: "Uploading…",
          sinEvidencias: "No attached evidence. You can attach the signed procedure, photos or diagrams.",
          evAdjuntada: "Evidence attached", evErr: "Could not upload the file",
          confirmDelEv: "Delete this evidence?", evDelOk: "Evidence deleted", evDelErr: "Could not delete",
        },
        norma: {
          est_pendiente_evidencia: "Pending evidence", est_pendiente_supervisor: "With supervisor",
          est_pendiente_gerente: "With manager", est_cumple: "Pass", est_no_cumple: "Fail",
          firmaDigital: "Digital signature", limpiar: "Clear",
          autorizacion: "Authorization", autorizacionHint: "They sign in agreement after reviewing this NOM.",
          rol_auditor: "Auditor", rol_supervisorEhs: "EHS Supervisor", rol_gerenteArea: "Area Manager",
          refirmar: "Sign again", firmarTitulo: "Sign as", nombreCompleto: "Full name",
          firmar: "Sign",
          comentarioOpcional: "Comment (optional)", nombreReq: "Name is required",
          firmaGuardada: "Signature saved",
          cargarEvidencia: "Upload evidence", areaInsp: "Inspected area *", selArea: "Select area",
          medicion: "Measurement / data (optional)", medicionPh: "E.g. \"320 lux\", \"32 °C\", \"GHS compliant\"",
          notaDesc: "Descriptive note", notaPh: "Describe what was observed...",
          frecReeval: "Re-evaluation frequency (months)", mes: "month", meses: "months",
          fotos15: "Photos (1–5) *", fotosSel: "{{n}} photo(s) selected",
          selAreaErr: "Select the area", sube1: "Upload at least 1 photo", max5: "Maximum 5 photos",
          evEnviada: "Evidence sent to supervisor", evErr: "Error sending evidence",
          enviando: "Sending...", enviarSup: "Send to supervisor", cancelar: "Cancel",
          vSupTitle: "Supervisor Verification (step 2/3)", vGerTitle: "Manager Validation (step 3/3)",
          evPresentada: "Submitted evidence", medicionB: "Measurement:", notaB: "Note:",
          motivoOblig: "The rejection reason is required", firmaReqAprobar: "Signature required to approve",
          capaGen: "High CAPA automatically generated", aprobado: "Approved", rechazadoResp: "Rejected, returns to owner",
          errProcesar: "Error processing", decision: "Decision", aprobar: "Approve", rechazar: "Reject",
          motivoRechazo: "Rejection reason (required)", comentario: "Comment",
          notaGerRechazo: "If you reject, a High CAPA with a 30-day deadline will be generated automatically.",
          notaSupRechazo: "The record will return to the owner for new evidence.",
          procesando: "Processing...", firmarAprobar: "Sign and approve", confirmarRechazo: "Confirm rejection",
          loadErr: "Could not load the data", pdfOk: "PDF downloaded", pdfErr: "Error generating PDF",
          loading: "Loading…", nomNotFound: "NOM not found.", volver: "Back",
          cumplimientoPorNorma: "Compliance by Norm", cumplimientoGlobal: "Overall compliance", exportarPdf: "Export PDF",
          requisitos: "Requirements", cumpleK: "Pass", noCumpleK: "Fail", pendientesK: "Pending",
          area: "Area:", medicionL: "Measurement:", frec: "Freq.: every {{n}} m", proxRev: "Next review:",
          verificarSup: "Verify (Supervisor)", validarGer: "Validate (Manager)", nuevaEvidencia: "New evidence",
          supervisorB: "Supervisor:", gerenteB: "Manager:", aprobadoT: "Approved", rechazadoT: "Rejected", validadoT: "Validated",
          capaAltoGen: "High CAPA generated · ID {{id}}…",
        },
        det: {
          backToList: "Back to list", notFound: "Inspection not found",
          area: "Area", inspector: "Inspector", fecha: "Date",
          compliance: "Compliance", downloadPdf: "Download PDF",
          cumple: "Pass", noCumple: "Fail", noAplica: "N/A", criticos: "Critical (High/Extreme)",
          estCumple: "Pass", estNoCumple: "Fail", estNoAplica: "N/A",
          matriz5x5: "5×5 Matrix:", notas: "Notes:", capaAuto: "→ Auto-generated CAPA (see table below)",
          jsaAuto: "Auto-generated JSA actions ({{n}})",
          thReq: "Req.", thCategoria: "Category", thHallazgo: "Finding", thNivel: "Level",
          thPlazo: "Deadline", thResponsable: "Owner", thEstado: "Status",
          porAsignar: "Unassigned",
          plazosAuto: "Automatic deadlines: Extreme 7 days · High 30 days · Medium 60 days · Low 90 days",
          verTodasCapas: "View all CAPAs →", obsGenerales: "General observations",
          resultadosReq: "Results by requirement", requisito: "Requirement {{n}}",
          resultadosCat: "Results by category", inspPlantaSub: "Plant Inspection — Safety walkthrough",
          firmasTitle: "Authorization signatures", autorizada: "AUTHORIZED",
          supervisorEhs: "EHS Supervisor", gerenteOperacion: "Operations Manager",
          firmaDe: "{{label}} signature", firmar: "Sign", pendienteFirma: "Pending signature",
          firmasNote: "Each person signs from their own account: the EHS Supervisor and the Operations Manager. The inspection becomes AUTHORIZED with both signatures.",
          captureSign: "Capture the signature before saving", signSaved: "Signature saved", signErr: "Could not sign",
          firmarComo: "Sign as {{label}}", nombreFirma: "Signer's name", trazarFirma: "Draw signature",
          guardarFirma: "Save signature", guardando: "Saving…",
          nivel_Bajo: "Low", nivel_Medio: "Medium", nivel_Alto: "High", nivel_Extremo: "Extreme",
          capa_abierta: "open", capa_cerrada: "closed", capa_en_proceso: "in progress",
        },
        nueva: {
          ipTitle: "New Plant Inspection", ipSub: "21 categories · 5×5 Matrix · Automatic CAPA for \"Fail\"",
          nomTitle: "New NOM Inspection", nomSub: "Official checklist · 5×5 Matrix · Automatic CAPA for \"Fail\"",
          areaZona: "Inspected Area / Zone *", areaZonaPh: "E.g. Maneuvering yard, Bay 1",
          inspector: "Inspector *", inspectorPh: "Inspector name", inspectorPhNom: "Auditor name",
          normaStps: "STPS Norm *", selNom: "Select NOM", areaInsp: "Inspected area *", selArea: "Select area",
          catEval: "Evaluation categories", categorias: "{{n}} categories", items: "{{n}} items",
          cambiar: "Change", definirMatriz: "Define matrix",
          adjuntarFoto: "Attach photo", subiendo: "Uploading…", fotos: "{{n}} photo(s)",
          notasPh: "Notes / finding detail",
          guardar: "Save inspection and generate CAPAs", guardando: "Saving…",
          matrizTitle: "5×5 Risk Matrix",
          matrizDesc: "Define the probability and severity of the finding to calculate the risk level.",
          probLabel: "Probability (1=Rare · 5=Almost certain)", sevLabel: "Severity (1=Insignificant · 5=Catastrophic)",
          nivel: "Level: {{n}}", confirmar: "Confirm",
          fotoCargada: "Photo uploaded", fotoErr: "Error uploading the photo",
          reqAreaInsp: "Complete Area/Zone and Inspector", reqNomArea: "Complete NOM, area and inspector",
          faltanCat: "{{n}} category(ies) still to evaluate", faltanItems: "{{n}} item(s) still to answer",
          faltanMatriz: "{{n}} \"Fail\" finding(s) without a 5×5 matrix",
          inspRegistrada: "Inspection registered • {{n}} auto-generated CAPAs", inspErr: "Error creating the inspection",
        },
        capas: {
          title: "JSA Management",
          subtitle: "Corrective actions auto-created from NOM inspections, medical surveillance (Not fit), ergonomics (Very high) and NOM-035 (clinical care)",
          estado: "Status", todos: "All", abierta: "Open", enProgreso: "In progress", cerrada: "Closed",
          nivelRiesgo: "Risk level", origen: "Source",
          inspNom: "NOM Inspections", vigMedica: "Medical Surveillance", ergonomia: "Ergonomics", psicosocial: "NOM-035 Psychosocial",
          srcNom: "NOM Inspection",
          reporteSeguridad: "Safety Report",
          thOrigen: "Source", thNom: "NOM", thReq: "Req.", thHallazgo: "Finding", thArea: "Area",
          thNivel: "Level", thFechaGen: "Generated", thPlazo: "Deadline", thResponsable: "Owner", thEstado: "Status",
          emptyFiltered: "No CAPAs with the applied filters.",
          editar: "Edit", editTitle: "Edit JSA action",
          responsable: "Owner", email: "Email", fechaLimite: "Deadline",
          urlEvidencia: "Closure evidence URL", comentariosCierre: "Closure comments",
          cancelar: "Cancel", guardar: "Save",
          noExport: "No CAPAs to export", excelOk: "Excel downloaded", pdfOk: "PDF downloaded",
          noReport: "No CAPAs for the report", reportOk: "Safety Report downloaded",
          capaSaved: "CAPA updated", saveErr: "Error saving",
          est_abierta: "open", est_en_progreso: "in progress", est_cerrada: "closed",
        },
        acto: {
          title: "Unsafe Acts and Conditions", subtitle: "Behavioral safety observation cards.",
          semana: "Week", todasSemanas: "All weeks", semanaN: "Week {{n}} · {{range}} ({{c}})",
          generando: "Generating…", descargarPdf: "Download PDF", nuevaTarjeta: "New card",
          tipo: "Type", todos: "All", actoInseguro: "Unsafe Act", condicionInsegura: "Unsafe Condition",
          estatus: "Status", abiertas: "Open", cerradas: "Closed",
          loading: "Loading…", emptyFiltered: "No cards with the applied filters.",
          riesgo: "Risk {{n}}", cerrada: "Closed", abierta: "Open", notificado: "Notified",
          turno: "Shift {{n}}", accion: "Action:", recomendaciones: "Recommendations:",
          responsableL: "Owner: {{n}}", sinResponsable: "No owner",
          enviarCorreo: "Send email", reabrir: "Reopen", cerrar: "Close",
          editarTarjeta: "Edit card", nuevaTarjetaT: "New card",
          tipoReq: "Type *", areaReq: "Area *", selArea: "Select area", nivelRiesgo: "Risk level",
          turnoL: "Shift", turnoPh: "Morning / Evening / Night",
          descObs: "Observation description *", recomendacionesL: "Recommendations", accionCorrectiva: "Corrective action",
          responsableCierre: "Closure owner", correoResp: "Owner's email", correoPh: "owner@company.com",
          reportadoPor: "Reported by", fecha: "Date", fotoOpcional: "Photo (optional)", subir: "Upload", tomarFoto: "Take photo",
          cancelar: "Cancel", guardando: "Saving…", guardarCambios: "Save changes", registrar: "Register",
          loadErr: "Error loading cards", fotoAgregada: "Photo added", fotoErr: "Error uploading the photo",
          selAreaErr: "Select an area", descObsErr: "Describe the observation",
          tarjetaActualizada: "Card updated", tarjetaRegistrada: "Card registered", saveErr: "Error saving",
          tarjetaCerrada: "Card closed", tarjetaReabierta: "Card reopened", err: "Error",
          sinCorreo: "This card has no owner email. Edit it to add one.",
          correoEnviado: "Email sent to {{email}}", correoErr: "Error sending email",
          confirmDelete: "Delete this card?", tarjetaEliminada: "Card deleted", delErr: "Error deleting",
          nivel_bajo: "Low", nivel_medio: "Medium", nivel_alto: "High", nivel_critico: "Critical",
          filtroArea: "Area", todasAreas: "All areas", filtroNombre: "Name",
          filtroNombrePh: "Reported by / Owner", limpiarFiltros: "Clear",
          fundamentoLegal: "Legal Basis (NOM)", causaEfecto: "Cause-Effect",
          sugerirIA: "Suggest with AI", sugiriendo: "Suggesting…",
          iaOk: "Suggestion applied. Review it before saving.", iaErr: "Could not generate the suggestion",
          descIAErr: "Write the finding description first",
          noData: "No cards for the report", nivel: "Level",
          enviarReporte: "Send by email", enviarReporteT: "Send Safety Report by email",
          destinatarios: "Recipients (comma-separated)", destinatariosOpc: "Recipients (optional, to send by email)",
          correoDestErr: "Enter at least one valid email", idiomaReporte: "Report language",
          enviando: "Sending…", enviarPdf: "Send PDF", reporteTarjetas: "Included cards",
          reporteEnviado: "Sent to {{n}} recipient(s)", reporteNoEnviado: "Could not send the email",
          reporteErr: "Error sending the report",
          recorridoCsh: "CSH Walkthrough", recorridoT: "Walkthrough Data — Health & Safety Committee",
          recorridoNota: "The currently filtered cards will be included", generarPdf: "Generate PDF",
          recorridoOk: "CSH Walkthrough downloaded", recorridoErr: "Error generating the CSH Walkthrough",
          recFecha: "Date", recRazon: "a) Company Name", recTrab: "b) Number of Workers",
          recDom: "c) Full Address", recTipoVer: "d) Verification Type", recFolio: "Folio",
          recHini: "e) Start Time", recHfin: "End Time",
          ordinario: "Ordinary", extraordinario: "Extraordinary",
          historial: "History", historialT: "CSH Walkthrough History",
          historialVacio: "No walkthroughs saved yet. Generate or send a CSH Walkthrough to see it here.",
          reimprimir: "Reprint", hallazgos: "findings", cierrePct: "% closed", enviadoA: "Sent to",
          pdfFirmado: "Signed PDF", pdfFirmadoErr: "Could not download the signed PDF",
          evidenciaFirmada: "Signed evidence available",
          soloFirmados: "Signed only", pendientesFirma: "Pending signature",
          historialSinFiltro: "No walkthroughs match the filter.",
          firmadosLbl: "signed", pendientesLbl: "pending",
          zipFirmados: "Signed ZIP", zipErr: "Could not download the signed ZIP",
          faltantesIA: "{{n}} card(s) missing Legal Basis or Cause-Effect",
          rellenarIA: "Fill missing with AI", rellenando: "Completing…",
          rellenadoIA: "AI completed {{n}} card(s)", sinFaltantes: "All cards already have Legal Basis and Cause-Effect",
          solicitarFirmas: "Signatures", solicitarFirmasT: "Request digital signatures",
          solicitarFirmasDesc: "Each signer will receive an email with a unique link to sign from their phone or computer. The signature will be stamped with date and time.",
          enviarSolicitud: "Send request", firmaCorreoErr: "Enter at least one valid email",
          firmaErr: "Could not send the signature request", firmasEnviadas: "Request sent to {{n}} signer(s)",
          firmado: "Signed", pendiente: "Pending", firmadoCerrado: "Signed / Closed",
          firmasLabel: "Signatures", nombrePh: "Name", correoEmpresaPh: "email@company.com",
        },
      },
      // ===== Administration (Permissions, Audit, Companies, Super Admin) =====
      admin: {
        loading: "Loading...", cancel: "Cancel", save: "Save", refresh: "Refresh",
        act: { read: "Read", create: "Create", edit: "Edit", delete: "Delete", approve: "Approve", deliver: "Deliver" },
        rolAll: "All",
        perm: {
          title: "Permissions Management",
          subtitle: "Dynamic matrix of roles × modules × actions (ISO 45001 · 5.3)",
          auditBtn: "Audit", resetBtn: "Restore defaults", save: "Save", noPending: "No pending changes",
          savedSuffix: "saved",
          confirmReset: "Restore the ENTIRE matrix to default values? Custom permissions will be erased.",
          restored: "Matrix restored", loadingMatrix: "Loading permissions matrix...",
          infoMain: "Each cell controls which actions a role can perform in each module. Changes take effect immediately (30s cache). Every change is recorded in the Audit log.",
          infoActions: "Actions: read, create, edit, delete, approve=approve/reject, deliver=deliver (PPE warehouse).",
          colModule: "Module", saveCell: "Save",
        },
        audit: {
          title: "Permissions Audit",
          subtitle: "Chronological history of changes to the permissions matrix",
          back: "Back", loading: "Loading...", empty: "No changes recorded",
          thFecha: "Date", thUsuario: "User", thRol: "Role", thModulo: "Module", thAntes: "Before", thDespues: "After",
          resetGlobal: "Global reset",
        },
        emp: {
          title: "Company Management",
          subtitle: "Creation and administration of companies (multi-company). Each company has its own isolated database.",
          newTitle: "New company", nameLabel: "Company name", namePh: "E.g. AvilesSafety",
          createBtn: "Create company", creating: "Creating…",
          nameMin: "Name must be at least 2 characters",
          createdToast: "Company \"{{name}}\" created", createErr: "Error creating the company", loadErr: "Error loading companies",
          confirmDelete: "Delete company \"{{name}}\"? All its data will be permanently deleted.",
          deletedToast: "Company \"{{name}}\" deleted", deleteErr: "Error deleting the company",
          registered: "Registered companies ({{n}})", loadingList: "Loading…", noneRegistered: "No companies registered.",
          principal: "Principal", active: "Active",
          markPrincipal: "Set as principal", createGerente: "Create Manager", customize: "Customize",
          administering: "Administering", administer: "Administer",
          confirmPrincipal: "Set \"{{name}}\" as the principal (default) company?",
          principalToast: "\"{{name}}\" is now the principal company", principalErr: "Error setting the principal company",
          footer: "When you click Administer, the system switches the active company and reloads so all data (users, inspections, reports) belong to that company.",
          brandTitle: "Customize branding — {{name}}", brandColor: "Brand color", brandPreview: "Preview",
          brandColorHint: "HEX format (#RRGGBB). Only affects this company.",
          brandLogo: "Company logo", uploadLogo: "Upload logo", uploading: "Uploading…",
          logoUploaded: "Logo uploaded", logoErr: "Error uploading the logo",
          brandLogoWarn: "⚠️ For the logo to display correctly, first click Administer on this company and then upload it.",
          saveBrand: "Save branding", savingBrand: "Saving…",
          brandSaved: "Branding updated for \"{{name}}\"", brandErr: "Error saving the branding",
          gerenteTitle: "Create Manager — {{name}}", gFullName: "Full name", gNamePh: "E.g. Juan Pérez",
          gEmail: "Email", gEmailPh: "manager@company.com", gPassword: "Temporary password", gPasswordPh: "Minimum 12 characters",
          gPasswordHint: "Minimum 12 characters, with uppercase, lowercase, number and symbol. The manager must change it on first login.",
          gNameMin: "Enter the manager's name", gCreatedToast: "Manager created for \"{{name}}\"", gErr: "Error creating the manager",
          isoBtn: "Test isolation", isoTitle: "Isolation test — {{name}}",
          isoRunning: "Running isolation test…", isoErr: "Error running the isolation test",
          isoPass: "Isolation OK", isoPassSub: "This company is fully separated; no other company can see its data.",
          isoFail: "Possible data leak!", isoFailSub: "The marker was visible from another company. Review the configuration before using in production.",
          isoType: "Isolation type", isoNamespace: "Folder / Namespace", isoVisible: "Marker visible in its folder",
          isoOthersChecked: "Other companies checked", isoLeaks: "Leaks detected", isoNoLeaks: "None",
          isoYes: "Yes", isoNo: "No", isoRerun: "Run again",
          sanitizeBtn: "Sanitize LGMG data", sanitizing: "Sanitizing…",
          sanitizeConfirm: "This will fix principal company (LGMG) data copied into OTHER companies: Follow-up Program owners → \"Unassigned\" and removes LGMG's default Plant Areas. It does not affect each company's own data. Continue?",
          sanitizeDone: "Sanitize complete: {{n}} owner(s) and {{a}} area(s) fixed",
          sanitizeNone: "All good: no LGMG data needed sanitizing",
          sanitizeErr: "Error running the sanitize task",
        },
        sa: {
          kicker: "Super Admin", title: "Access Control",
          subtitle: "Menu and submenu visibility by role",
          resetDefault: "Restore default", saving: "Saving…", saveChanges: "Save changes", noChanges: "No changes",
          tabMenu: "Menu visibility", tabUsers: "Users & locks",
          loadMatrixErr: "Error loading menu matrix", loadUsersErr: "Error loading users",
          accessDenied: "Access denied", accessDeniedMsg: "This section is reserved for the Super Admin.", loading: "Loading…",
          gerenteAlways: "The Manager always has full access",
          changesSaved: "Changes saved", saveErr: "Error saving",
          confirmReset: "Restore default visibility for all roles?", resetDone: "Restored to default values", resetErr: "Error restoring",
          quickPermTitle: "CRUD Permissions", quickPermSub: "View / create / edit / delete by module",
          quickAuditTitle: "Audit", quickAuditSub: "Permission change history",
          quickUsersTitle: "Users", quickUsersSub: "Create / assign roles to personnel",
          gerenteFullNote: "The Manager role always has full access to the system. It cannot be restricted.",
          removeAll: "Remove all", activateAll: "Enable all",
          unsavedBanner: "You have unsaved changes", saveBtn: "Save",
          loadingUsers: "Loading users…",
          confirmLock: "{{verb}} {{name}} ({{email}})?", verbLock: "Lock", verbUnlock: "Unlock",
          userLocked: "User locked", userUnlocked: "User unlocked", err: "Error",
          deleteKeyword: "DELETE",
          deletePrompt: "⚠ DELETING {{name}} ({{email}}) is PERMANENT.\nType DELETE to confirm:",
          deleteCancel: "Cancelled — you must type DELETE", userDeleted: "User deleted", deleteErr: "Error deleting",
          usersCount: "Users ({{n}})",
          gerenteNote: "As a Manager you can lock/unlock supervisors, warehouse and users. Only the Super Admin can lock another Manager.",
          thUser: "User", thRole: "Role", thArea: "Area", thStatus: "Status", thActions: "Actions",
          stActive: "Active", stLocked: "Locked", lockedBy: "by {{name}}",
          btnLock: "Lock", btnUnlock: "Unlock",
          whySelf: "Yourself", whySuper: "Protected (Super)", whyGerente: "Only Super Admin can lock Managers",
          deleteTitle: "Delete user permanently",
        },
      },
      // ===== Environment (Waste, Consumption, Compliance, Logbook, Exit Passes) =====
      amb: {
        loading: "Loading...", save: "Save", cancel: "Cancel", saving: "Saving...",
        register: "Register", allTypes: "All types", close: "Close",
        res: {
          title: "Waste Management",
          subtitle: "Logbook of hazardous, special-handling and urban solid waste (LGEEPA · NOM-052-SEMARNAT)",
          addBtn: "Register Waste",
          tipoRP: "Hazardous (RP)", tipoRME: "Special Handling (RME)", tipoRSU: "Urban Solid (RSU)",
          records: "records",
          thFecha: "Date", thTipo: "Type", thResiduo: "Waste", thClave: "SEMARNAT Code",
          thCretib: "CRETIB", thArea: "Area", thCantidad: "Quantity", thManifiesto: "Manifest",
          thDestino: "Destination", thEstatus: "Status",
          empty: "No waste records", genFrom: "Generated from {{folio}}", bitacora: "Logbook",
          formTitle: "Register Waste",
          fTipo: "Type", fFechaGen: "Generation date", fNombre: "Waste name",
          fNombrePh: "E.g. Rags soaked with solvents",
          fClave: "SEMARNAT Code", fClavePh: "E.g. RP-04/02", fCretib: "CRETIB",
          fArea: "Generating area", fCantidad: "Quantity", fUnidad: "Unit",
          secManifiesto: "Manifest & Disposal",
          fAlmacen: "Temporary storage", fAlmacenPh: "Internal location", fDisposicion: "Disposal",
          dispAlmacen: "Temporary storage", dispTransporte: "In transit", dispDispuesto: "Final disposal",
          fManifiesto: "Manifest number", fManifiestoPh: "SEMARNAT manifest",
          fFechaDisp: "Disposal date", fTransportista: "Authorized carrier",
          fAutTrans: "Carrier authorization #", fDestino: "Final destination", fDestinoPh: "Receiving company",
          fAutDestino: "Destination authorization #", fCosto: "Disposal cost", fObs: "Notes",
          toastSaved: "Waste registered",
        },
        cons: {
          title: "Consumption",
          subtitle: "Monthly record of consumption, cost and carbon footprint (SEMARNAT/INECC factor)",
          addBtn: "Register Consumption",
          kAnio: "Current Year Consumption", kCosto: "Current Year Cost", kCo2: "CO₂e Footprint (Year)",
          serie: "Historical series", serieEmpty: "No data. Record at least one period.",
          consumoLeg: "Consumption ({{u}})",
          thPeriodo: "Period", thMedidor: "Meter", thArea: "Area", thConsumo: "Consumption",
          thCosto: "Cost", thCo2: "CO₂e", thObs: "Notes", empty: "No records",
          formTitle: "Register Consumption",
          fTipo: "Type", fPeriodo: "Period (YYYY-MM)", fMedidor: "Meter / Account",
          fMedidorPh: "E.g. CFE-12345", fArea: "Area", fAreaPh: "Plant / Offices",
          fConsumo: "Consumption", fUnidad: "Unit", fCosto: "Cost", fObs: "Notes",
          toastSaved: "Consumption registered",
          tAgua: "Water", tElectricidad: "Electricity", tGasLp: "LP Gas", tGasNatural: "Natural Gas", tDiesel: "Diesel", tGasolina: "Gasoline",
        },
        cump: {
          title: "Environmental Compliance",
          subtitle: "Permits, licenses and obligations before SEMARNAT, CONAGUA, PROFEPA",
          addBtn: "New Permit",
          kVigentes: "Valid", kPorVencer: "Expiring (≤60d)", kVencidos: "Expired", kIndefinidos: "Indefinite",
          filterAll: "All", empty: "No permits",
          stVigente: "Valid", stPorVencer: "Expiring", stVencido: "Expired", stIndefinido: "Indefinite",
          lAutoridad: "Authority:", lEmitido: "Issued:", lVence: "Expires:", lResponsable: "Owner:", indef: "Indefinite",
          valPendSup: "Pending supervisor", valPendGer: "Pending manager", valValidado: "Validated", valRechazado: "Rejected",
          verArchivo: "View file", sinArchivo: "No file", reemplazar: "Replace file", subir: "Upload file",
          supAprueba: "Supervisor approves", gerValida: "Manager validates", rechazar: "Reject",
          rowSup: "Supervisor:", rowGer: "Manager:", aprobado: "Approved", rechazado: "Rejected", validado: "Validated",
          toastUploaded: "File uploaded", toastApproved: "Approved", toastRejected: "Rejected", toastDeleted: "Deleted",
          promptReject: "Rejection reason (required):", promptComment: "Comment (optional):",
          rejectNeedReason: "Reason required to reject", confirmDelete: "Delete permit \"{{name}}\"?",
          formTitle: "New Environmental Permit",
          fTipo: "Permit type", fNombre: "Name / Description", fNumero: "Document number",
          fAutoridad: "Authority", fEmision: "Issue date", fVencimiento: "Expiration date",
          fResponsable: "Owner", fResponsablePh: "HSE Coordination", fObs: "Notes",
          toastSaved: "Permit registered",
          tLAU: "Single Environmental License (LAU)", tCOA: "Annual Operation Report (COA)",
          tMIA: "Environmental Impact Statement (MIA)", tRP: "Hazardous Waste Generator Registry",
          tConaguaD: "CONAGUA Permit — Discharge", tConaguaE: "CONAGUA Permit — Extraction",
          tLFE: "State Operating License", tOtro: "Other",
        },
        bit: {
          title: "Waste Logbook",
          subtitle: "Record of waste that work areas hand over to the warehouse (hazardous, special-handling and urban solid).",
          subtitleLink: "Each delivery automatically generates a linked record in the Waste (SEMARNAT) module.",
          reporteBtn: "Monthly Report", addBtn: "Register Delivery",
          tipoRP: "Hazardous (RP)", tipoRME: "Special Handling (RME)", tipoRSU: "Urban Solid (RSU)", entregas: "deliveries",
          thFolio: "Folio", thFecha: "Date", thTipo: "Type", thDescripcion: "Description",
          thArea: "Source area", thCantidad: "Quantity", thEntregado: "Delivered by",
          thRecibido: "Received at warehouse", thFirmas: "Signatures",
          empty: "No deliveries registered", pendiente: "Pending",
          reporteTitle: "Monthly Report (PDF)", reporteMes: "Report month",
          reporteHint: "Consolidated by type and area, with totals and delivery detail for the month (for SEMARNAT/COA and audits).",
          generarPdf: "Generate PDF",
          lFecha: "Date:", lArea: "Area:", lCantidad: "Quantity:", lDescripcion: "Description:",
          entregadoSlot: "Delivered by (area)", recibidoSlot: "Received at warehouse", eliminar: "Delete",
          confirmDelete: "Delete record {{folio}}?", toastDeleted: "Record deleted",
          captureSign: "Capture the signature", toastSigned: "Signature saved",
          firmar: "Sign", nombrePh: "Name", traceSign: "Draw signature", pendSign: "Pending signature",
          formTitle: "Register Delivery to Warehouse",
          fFecha: "Date", fTipo: "Waste type", fDescripcion: "Waste description",
          fDescripcionPh: "E.g. Solvent-soaked rags, cardboard, metal shavings…",
          fArea: "Source area", fCantidad: "Quantity", fUnidad: "Unit",
          fEntregado: "Delivered by (area)", fEntregadoPh: "Worker name",
          fRecibido: "Received at warehouse by", fRecibidoPh: "Warehouse owner", fObs: "Notes",
          validateMsg: "Complete description, quantity and who delivers", toastSaved: "Delivery registered in logbook",
        },
        pase: {
          listTitle: "Exit Passes", listKicker: "Environment · Waste", sixSigns: "Authorization with 6 signatures",
          newBtn: "New pass", empty: "No exit passes.", completo: "Complete", firmasOf: "{{n}}/6 signatures",
          newTitle: "New Exit Pass", newDesc: "Authorization with 6 signatures for waste exit",
          fFecha: "Date", fResiduoReg: "Registered waste (optional)", selPlaceholder: "Select or type",
          manual: "Manual entry", fNombre: "Waste name *", fTipo: "Type",
          tipoRP: "RP (Hazardous)", tipoRME: "RME (Special Handling)", tipoRSU: "RSU (Urban)",
          fCantidad: "Quantity *", fUnidad: "Unit", fManifiesto: "Manifest No.",
          fEmpresa: "Carrier company *", fAutSemarnat: "SEMARNAT authorization",
          fVehiculo: "Vehicle", fVehiculoPh: "Plates, make and model", fConductor: "Driver",
          fDestino: "Final destination *", fAutDestino: "Destination authorization", fObs: "Notes",
          createBtn: "Create pass", creating: "Creating…",
          reqFields: "Waste, company and destination are required", toastCreated: "Pass created, ready for signatures",
          firmarAs: "Sign as {{role}}", fNombreCompleto: "Full name *",
          fComentario: "Comment (optional)", reqNombre: "Name required", reqFirma: "Signature required",
          toastSigned: "Signature registered", firmar: "Sign", firma: "Signature", limpiar: "Clear",
          back: "Back to list", kicker: "Exit Pass",
          lFecha: "Date", lTipo: "Type", lCantidad: "Quantity", lManifiesto: "Manifest",
          lEmpresa: "Company", lVehiculo: "Vehicle", lConductor: "Driver", lDestino: "Destination",
          autorizaciones: "Authorizations", noAuthRole: "Your role cannot authorize this signature",
          loadError: "Error loading passes", pdfError: "Error generating PDF",
          confirmDelete: "Delete this exit pass?", toastDeleted: "Deleted",
          rRealizo: "Performed by", rRealizoWho: "Operator who executed the exit",
          rEmpresa: "Carrier company", rEmpresaWho: "Driver / representative",
          rSupervisor: "Supervisor", rSupervisorWho: "Area supervisor",
          rGerente: "Manager", rGerenteWho: "HSE / Operations Manager",
          rFinanzas: "Finance", rFinanzasWho: "Financial validation",
          rEmbarques: "Shipping", rEmbarquesWho: "Shipping control",
        },
      },
      lecciones: {
        eyebrow: "HSE · Continuous improvement",
        title: "Lessons Learned",
        subtitle: "Automatic weekly compilation (Mondays) of unsafe acts, incidents, A3, CAPA and inspections.",
        generar: "Generate compilation",
        loading: "Loading…",
        empty: "No lessons yet.",
        emptyHint: 'Press "Generate compilation" to create last week\'s.',
        searchPlaceholder: "Search by folio or title…",
        yearAll: "All",
        noResults: "No results for the filters.",
        registros: "records",
        back: "Back to list",
        publicado: "Published",
        borrador: "Draft",
        auto: "Auto",
        ia: "AI",
        weekOf: "Week {{ini}} to {{fin}}",
        secDescripcion: "1. Description of the unsafe act/condition or incident",
        secCausa: "2. Root cause",
        secAcciones: "3. Corrective actions",
        secRecomendaciones: "4. Future recommendations",
        resumenLabel: "Executive summary (AI)",
        resumenPlaceholder: 'Use "Generate with AI" to draft the week\'s summary.',
        generarIA: "Generate with AI",
        generandoIA: "Generating…",
        traducir: "Translate to English",
        traduciendo: "Translating…",
        tTraducirOk: "Content translated to English with AI",
        save: "Save",
        saving: "Saving…",
        markPublished: "Mark as published",
        pdf: "PDF",
        acusePrompt: "Confirm that you read this lesson learned.",
        confirmarLectura: "Confirm reading",
        registrando: "Registering…",
        confirmaste: "You confirmed reading",
        confirmaronReport: "{{acked}} of {{total}} confirmed",
        anexo: "Appendix · Source records",
        thOrigen: "Source", thArea: "Area", thFecha: "Date", thDescripcion: "Description",
        comparativoTitle: "Weekly comparison of events by source",
        exportar: "Export",
        legActos: "Acts/Cond.", legIncidentes: "Incidents", legA3: "A3", legCapa: "CAPA/JSA", legSalud: "Occ. health",
        cumplimientoTitle: "Reading compliance by lesson",
        cumplimientoMeta: "{{n}} people · target {{meta}}%",
        configurar: "Settings",
        bajoMeta: "Below target",
        pendientesTitle: "Pending confirmation ({{n}})",
        todosConfirmaron: "All personnel confirmed reading.",
        excel: "Excel",
        recordarPendientes: "Remind pending",
        enviando: "Sending…",
        recordarUno: "Remind only this person",
        settingsTitle: "Lessons Settings",
        settingsDesc: "Adjust the compliance target and the reminder frequency.",
        metaLabel: "Compliance target (%)",
        metaHint: 'Lessons below this % are highlighted as "Below target".',
        diasLabel: "Resend acknowledgement reminder every (days)",
        diasHint: "Resent to those who haven't confirmed reading a published lesson.",
        cancelar: "Cancel",
        genTitle: "Generate weekly compilation",
        genDesc: "Records from the week (Monday to Sunday) are collected. Leave the date empty for last week.",
        genFechaLabel: "Date within the week (optional)",
        tLoadError: "Could not load lessons",
        tOpenError: "Could not open the lesson",
        tGenOk: "Compilation created ({{n}} records)",
        tGenExist: "That week already existed; opened it",
        tSaved: "Saved",
        tIAOk: "Summary, root cause and recommendations generated with AI",
        tAcuseOk: "Reading acknowledgement recorded",
        tDeleteConfirm: "Delete this lesson learned?",
        tDeleted: "Deleted",
        tPdfError: "Could not generate the PDF",
        tExportError: "Could not export the comparison",
        tExcelError: "Could not export the list",
        tSettingsOk: "Settings saved",
        tRecordarOk: "Reminder sent to {{n}} pending",
        tRecordarNone: "Already confirmed or no pending",
      },

    },
  },
};

const initial = (typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY)) || "es";

i18n.use(initReactI18next).init({
  resources,
  lng: initial,
  fallbackLng: "es",
  interpolation: { escapeValue: false },
});

export function setLang(lng) {
  try { window.localStorage.setItem(STORAGE_KEY, lng); } catch (_) {}
  i18n.changeLanguage(lng);
}

export default i18n;
